// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Graphik-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Graphik-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Graphik-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("images/upserve_loader_icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Graphik";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Graphik";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Graphik";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
  font-weight: 700;
  font-style: normal;
}
.icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: baseline;
}
.icon.star {
  fill: none;
}
.icon.large {
  width: 50px;
  height: 60px;
}
.icon-wrapper.circled {
  background-color: white;
  border-radius: 50%;
  display: inline-block;
  padding: 8px;
  text-align: center;
  height: 20px;
  width: 20px;
}
button {
  border-radius: 5px;
  border: 0;
  cursor: pointer;
  display: inline-block;
  line-height: 150%;
  padding: 0.75em 12px;
  text-align: center;
  transition: background-color 0.1s ease-in;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
button.caps {
  font-weight: 600;
  text-transform: uppercase;
}
button.large {
  font-size: 1.125rem;
  font-weight: 600;
}
button.medium {
  font-size: 1rem;
  font-weight: 600;
}
button.small {
  font-size: 0.875rem;
}
button:hover {
  color: #ffffff;
  border: 0;
}
button.sharp-corners {
  border-radius: 0;
}
button.secondary {
  background-color: #ffffff;
  border: 1px solid #445a82;
  color: #445a82;
}
button.secondary:hover {
  background-color: #ffffff;
}
button.text {
  color: #445a82;
  font-size: 1em;
  padding-left: 0;
  padding-right: 0;
}
button.disabled {
  color: #ffffff;
}
button.disabled:hover {
  background-color: #5a5a5a;
}
.checkbox-option {
  display: inline-block;
  position: relative;
}
.checkbox-option label {
  padding: 0 5px;
  cursor: pointer;
}
.checkbox-option label.disabled {
  opacity: 0.75;
  cursor: default;
}
.checkbox-option .checkmark {
  left: 4px;
  position: absolute;
  top: 8px;
  display: none;
  height: 12px;
  width: 12px;
}
.text-alerts {
  display: inline-flex;
  align-items: center;
  line-height: 22px;
}
input[type="checkbox"] {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 1px solid #445a82;
  height: 14px;
  width: 14px;
  position: relative;
  top: 5px;
  cursor: pointer;
}
input[type="checkbox"]:checked {
  background-color: #445a82;
  position: relative;
  top: 5px;
}
input[type="checkbox"]:checked + label .checkmark {
  display: inline-block;
}
input[type="checkbox"]:disabled {
  cursor: default;
  opacity: 0.75;
  border-color: #5a5a5a;
}
.form .row {
  margin: 13px 0;
  display: flex;
  align-items: center;
}
.form .row:first-of-type {
  margin-top: 0;
}
.form .row .multi-field {
  display: flex;
  flex-grow: 1;
  gap: 20px;
}
.form .row .label,
.form .row .label-text,
.form .row label {
  width: 120px;
  font-weight: 600;
  font-size: 0.875rem;
  color: #5a5a5a;
  flex-shrink: 0;
}
.form .row label.cvv,
.form .row label.zip {
  margin-right: 4px;
  margin-left: 20px;
}
.form .row label.shrink,
.form .row .label-text.shrink {
  flex-shrink: 1;
}
@media (min-width: 1025px) {
  .form .row label.cvv,
  .form .row label.zip {
    flex-shrink: 0;
    padding-right: 2px;
    text-align: right;
    width: auto;
  }
}
.form .row .expiry-divider {
  font-size: 1.45rem;
}
.form .row .text-input {
  flex-grow: 1;
  flex-shrink: 1;
}
.text-input input {
  color: #88888d;
  width: 100%;
  height: 100%;
  padding: 8px;
  font-size: 1rem;
  font-weight: 300;
  border-radius: 2px;
  border: 1px solid #ededed;
  box-sizing: border-box;
}
.text-input input.exp {
  max-height: 37px;
}
.text-input.error input {
  border: 1px solid #e02948;
}
.text-input.error .error-text {
  margin: 2px;
  color: #e02948;
  font-size: 0.75rem;
  font-weight: 400;
  display: block;
}
.adyen-input {
  flex-grow: 1;
}
.adyen-input span[data-cse] {
  line-height: 0;
  display: block;
  background: white;
}
.adyen-input iframe {
  border-radius: 2px;
  border: 1px solid #ededed;
  box-sizing: border-box;
  height: 33px;
  padding: 0;
  width: 100%;
}
.adyen-input.error iframe {
  border-color: #e02948;
}
.adyen-input.focus iframe {
  border: 2px solid #101010;
}
.toggle {
  display: flex;
}
.toggle .toggle-option {
  flex-grow: 1;
  text-align: center;
  padding: 10px;
  font-size: 0.875rem;
  color: #88888d;
  font-weight: 400;
  border: 1px solid #ededed;
}
.toggle .toggle-option.selected {
  color: #445a82;
  border-color: #445a82;
}
.picker {
  display: inline-block;
  width: 100%;
  background-color: #ffffff;
}
.picker.expanded .options {
  z-index: 500;
  border: 1px solid #ededed;
}
.picker.expanded .options .option.selected {
  width: 100%;
}
.picker.expanded .options .option.selected .icon {
  position: relative;
  top: -1px;
  height: 13px;
  width: 13px;
}
.picker.expanded .options .option.selected .icon #toggle {
  stroke: #445a82;
}
.picker.expanded .options .option:last-of-type {
  border-top: 1px solid #ededed;
  font-weight: 400;
  width: 100%;
}
.picker .current {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  border: 1px solid #ededed;
  border-radius: 5px;
  margin: 0;
}
.picker .current .option .icon {
  display: none;
}
.picker .current .icon-wrapper {
  position: relative;
  top: 13px;
  right: 21px;
}
.picker .current .icon {
  width: 12px;
  height: 12px;
  fill: #445a82;
}
.picker.error .current {
  border-color: #e02948;
}
.picker .error-text {
  margin: 2px;
  color: #e02948;
  font-size: 0.75rem;
  font-weight: 400;
}
.picker .options {
  border-radius: 5px;
  margin: 2px 0 0;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}
.picker .option {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 240px;
  padding: 10px 20px;
  cursor: pointer;
  box-sizing: border-box;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader {
  position: relative;
}
.loader .indicator {
  position: absolute;
  top: -10px;
  right: -10px;
  bottom: -10px;
  left: -10px;
  z-index: 1000;
}
.loader .indicator .logo {
  position: absolute;
  top: 150px;
  left: 50%;
  margin-left: -20px;
  width: 44px;
  height: 44px;
  border: 2px solid transparent;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
}
.loader .indicator:after {
  content: ' ';
  position: absolute;
  top: 150px;
  left: 50%;
  margin-left: -20px;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  border: 4px solid rgba(0, 0, 0, 0.2);
  border-top-color: rgba(0, 0, 0, 0.3);
  animation: spin 1s infinite linear;
}
.loader.large .indicator .logo {
  zoom: 2;
}
.loader.large .indicator:after {
  zoom: 2;
}
.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 3000;
  background: rgba(51, 51, 51, 0.8);
  transition: background 0.4s ease-out;
}
.modal {
  position: fixed;
  z-index: 3500;
  top: 50%;
  left: 0px;
  right: 0px;
  margin: 0 auto;
  width: 500px;
  max-width: 100%;
  border-radius: 5px;
  background-color: #ffffff;
  text-align: left;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  transform: translateY(-50%);
}
.modal .close {
  float: right;
}
.modal .close .icon-wrapper {
  position: absolute;
  height: 14px;
  right: 20px;
  top: 20px;
}
.modal .close .icon {
  fill: #88888d;
  width: 14px;
  height: 14px;
}
.modal header {
  padding: 18px 22px;
  border-bottom: 1px solid #ededed;
}
.modal header .mobile-title {
  color: #5a5a5a;
  font-size: 1.25rem;
  display: none;
}
.modal .contents {
  margin: 20px;
}
.modal .contents .message {
  margin-bottom: 20px;
}
.modal .login-footer {
  padding: 8px;
  text-align: center;
  border-top: 1px solid #ededed;
}
.modal .login-footer a {
  color: #000000;
}
.modal .login-footer a .logo-icon {
  height: 39px;
  width: 162px;
  position: relative;
  top: 2px;
}
.alert-modal .contents {
  text-align: center;
  width: 420px;
  margin: 20px auto;
}
.alert-modal .contents .button {
  width: 100%;
  box-sizing: border-box;
}
.confirm-modal .confirm-actions {
  text-align: right;
}
.confirm-modal .confirm-actions .button {
  margin-left: 5px;
  width: 120px;
}
.preview-banner {
  background-color: #373737;
  color: #ffffff;
  height: 100px;
}
.preview-banner button {
  border: 1px solid white;
}
.preview-banner a {
  text-decoration: underline;
}
.preview-banner .inner {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-content: center;
  width: 1024px;
  margin: 0 auto;
  height: 100%;
}
.preview-banner .inner .left {
  align-self: center;
  flex-basis: 80%;
  line-height: 1.2rem;
  padding-left: 20px;
}
.preview-banner .inner .left .text {
  margin: 10px 0;
}
.preview-banner .inner .left .text .emphasis {
  font-weight: 600;
}
.preview-banner .inner .left a {
  color: #ffffff;
}
.preview-banner .inner .right {
  padding-left: 20px;
  align-self: center;
}
.preview-banner .inner .right a {
  border: 1px solid #ffffff;
  padding: 0px 30px;
}
.preview-banner .modal-content {
  padding: 20px;
  color: #88888d;
}
.preview-banner .modal-content .body {
  margin-bottom: 20px;
}
.preview-banner .modal-content button {
  margin: 10px 0;
  width: 60%;
}
.preview-banner .modal-content .animation {
  width: 100px;
  height: 100px;
}
.preview-banner .modal-content .center {
  display: flex;
  align-items: center;
  flex-direction: column;
}
html {
  height: 100%;
  font-size: 87.5%;
}
body {
  margin: 0;
  height: 100%;
}
#root {
  height: 100%;
}
h1,
h3 {
  color: #88888d;
  font-weight: 300;
}
h2 {
  color: #5a5a5a;
  font-size: 1.45rem;
  font-weight: 400;
  margin: 0.1em 0;
}
h3 {
  font-size: 1.125rem;
}
h4 {
  color: #5a5a5a;
  font-size: 1.25rem;
  font-weight: 400;
  margin: 20px 0 0;
}
h5 {
  margin-top: 0;
  color: #5a5a5a;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 10px;
}
a {
  color: #445a82;
  cursor: pointer;
  text-decoration: none;
}
table {
  font-size: 0.875rem;
  border-collapse: collapse;
}
table th {
  font-weight: 300;
  padding: 0px 12px 10px;
}
table td {
  padding: 10px 12px 28px;
}
button {
  font-family: "Graphik", sans-serif;
}
input {
  font-family: "Graphik", sans-serif;
}
ul {
  list-style: none;
  padding-left: 0;
}
.bold {
  font-weight: 700;
}
.semi-bold {
  font-weight: 600;
}
.clickable {
  cursor: pointer;
}
.hidden {
  display: none !important;
}
.hidden-iframe {
  border: none;
  display: none;
}
.landing {
  text-align: center;
}
.landing .ghost {
  width: 100px;
  height: 100px;
  margin: 40px 0 0 -40px;
}
.freeze-body {
  overflow: hidden;
  position: fixed;
  width: 100vw;
  height: 100vh;
}
.app {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  min-height: 100%;
  position: relative;
  line-height: 1.5;
}
.app .header {
  display: flex;
  background-size: auto 100%;
  width: 100%;
  height: 128px;
  padding: 30px 40px;
  box-sizing: border-box;
  color: #ffffff;
  text-shadow: 0 0 10px rgba(45, 44, 158, 0.25);
}
.app .header .location-details {
  flex-grow: 1;
}
.app .header .location-details .location-name {
  font-size: 1.875rem;
  font-weight: 600;
  letter-spacing: 0.025em;
  line-height: 1.2em;
  background-color: transparent;
  border-radius: none;
  border: 0;
  color: auto;
  display: auto;
  padding: 0;
  text-align: inherit;
}
.app .header .location-details .hours {
  font-size: 1rem;
  font-weight: bold;
}
.app .header .location-details .website,
.app .header .location-details .store-info {
  font-weight: 400;
  font-size: 0.875rem;
  letter-spacing: 0.035em;
}
.app .header .location-details .website a,
.app .header .location-details .store-info a {
  color: #ffffff;
}
.app .header .location-details .website .address-spacer,
.app .header .location-details .store-info .address-spacer {
  padding: 0 3px;
}
.app .header .login {
  display: flex;
  align-items: baseline;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 400;
  text-shadow: 0 0 10px rgba(45, 44, 158, 0.3);
}
.app .header .login .separator {
  padding: 6px;
}
.app .header .login .icon-wrapper {
  margin-right: 6px;
}
.app .header .login .icon-wrapper,
.app .header .login .icon.user {
  position: relative;
  top: 2px;
  width: 17px;
  height: 17px;
}
.app .header .auth-modal {
  text-shadow: none;
}
.app .header .auth-modal .auth-modal-button {
  display: inline-block;
  margin-left: 25px;
  position: relative;
  text-align: center;
  cursor: pointer;
}
.app .header .auth-modal .auth-modal-button .icon-wrapper {
  margin-bottom: 5px;
}
.app .header .auth-modal .auth-modal-button .icon-overlay {
  font-size: 11px;
  left: 50%;
  position: absolute;
  top: 13px;
  transform: translateX(-50%);
}
.app .header .auth-modal .contents {
  color: #88888d;
  width: 400px;
  margin: 20px auto;
  text-align: left;
  font-size: 1rem;
}
.app .header .auth-modal .contents .modal-copy {
  margin-bottom: 20px;
}
.app .header .auth-modal .contents.with-loader {
  height: 284px;
}
.app .header .auth-modal .contents.with-loader .loader {
  top: -50px;
}
.app .header .auth-modal .contents input {
  height: 38px;
  margin: 5px 0;
}
.app .header .auth-modal .contents .reset-password-button,
.app .header .auth-modal .contents .login-button,
.app .header .auth-modal .contents .set-password-button,
.app .header .auth-modal .contents .button {
  display: block;
  width: 100%;
  height: 50px;
  margin: 10px 0;
  box-sizing: border-box;
  font-size: 1rem;
}
.app .header .auth-modal .contents .forgot-password,
.app .header .auth-modal .contents .create-account,
.app .header .auth-modal .contents .show-login {
  display: block;
  font-weight: 400;
  margin: 15px 0;
}
.app .header .auth-modal .outlined-button {
  padding: 6px 8px;
  border: 2px solid #ffffff;
  background-color: #5a5a5a;
  border-radius: 5px;
  color: #ffffff;
  display: flex;
  align-items: center;
  line-height: 1;
  gap: 10px;
  font-size: 16px;
}
.app .header .auth-modal .outlined-button .icon {
  width: 16px;
  height: 16px;
}
.app .header .auth-modal .account-info {
  color: #ffffff;
  font-size: 16px;
  cursor: auto;
}
.app .header .auth-modal .account-info .icon {
  width: 16px;
  height: 16px;
}
.app .header .auth-modal .account-info a {
  color: #ffffff;
  text-decoration: underline;
}
.app .header .auth-modal .sent-modal .message {
  margin: 30px auto;
}
.app .header .auth-modal .sent-modal .message div + div {
  margin-top: 15px;
}
.app .footer {
  background-color: #ffffff;
  bottom: 0;
  box-sizing: border-box;
  color: #000000;
  display: flex;
  font-size: 0.875rem;
  height: 44px;
  padding: 0 14px;
  vertical-align: middle;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  align-items: center;
}
.app .footer .outside-reference {
  flex-grow: 1;
  text-align: left;
  padding: 14px 0;
}
.app .footer .outside-reference .separator {
  padding: 4px;
  color: #445a82;
}
.app .footer .upserve {
  display: block;
  height: -moz-fit-content;
  height: fit-content;
}
.app .footer .upserve a {
  display: block;
  line-height: 0;
}
.app .footer .upserve .logo-icon {
  width: 108px;
}
.app .location-info {
  padding: 20px;
  margin-bottom: 20px;
}
.app .location-info .promo-description {
  font-size: 1.125rem;
  color: #88888d;
  border-bottom: 1px solid #ededed;
  line-height: 1.8em;
  padding-bottom: 20px;
}
.app .location-info .lower {
  display: flex;
  flex-direction: row;
  margin: 20px 0;
  padding-bottom: 20px;
}
.app .location-info .lower .location {
  color: #5a5a5a;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.8em;
  margin-right: 50px;
  margin-bottom: 20px;
}
.app .location-info .lower .location .website {
  margin-top: 20px;
}
.app .location-info .lower .location .website a {
  color: #445a82;
}
.app .content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
}
.app .content > .loader {
  flex-basis: 100%;
}
.app .content.loyalty-only {
  padding: 0;
}
.app .content .card {
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}
.app .content .card.main-view {
  margin-bottom: 60px;
}
.app .content .message-banner {
  padding: 0 20px;
  margin: 20px 0;
  background-color: #ffedee;
  width: 100%;
  display: flex;
  align-items: center;
}
.app .content .message-banner .icon {
  color: #c8341e;
  height: 30px;
  width: auto;
}
.app .content .message-banner .message-content {
  padding-left: 20px;
}
.app .content .message-banner .message-header {
  font-weight: 600;
}
.app .content .reward-progress-bar {
  padding: 10px 20px;
  border: 1px solid #7fcf26;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.app .content .reward-progress-bar span {
  margin: 0 5px;
  color: #88888d;
}
.app .content .reward-progress-bar .bar {
  width: 100%;
  height: 18px;
  flex-grow: 1;
  border-radius: 5px;
  background-color: #f5f5f5;
  overflow: hidden;
}
.app .content .reward-progress-bar .bar .completed {
  display: inline-block;
  height: 18px;
  width: 0%;
  margin: 0;
  background-color: #7fcf26;
}
.app .content .mini-loyalty {
  margin: 5px;
}
.app .content .mini-loyalty .reward {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 650px;
  padding: 5px;
  box-sizing: border-box;
}
.app .content .mini-loyalty .reward.mini-point-reward .reward-content {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
}
.app .content .mini-loyalty .reward.mini-point-reward .reward-content .description {
  font-size: 0.875rem;
  color: #5a5a5a;
  margin: 0 10px;
}
.app .content .mini-loyalty .reward.mini-point-reward .reward-content .reward-progress-bar {
  border: none;
  align-self: flex-end;
  flex-basis: 500px;
  flex-grow: 0;
}
.app .content .mini-loyalty .reward .icon-wrapper {
  margin: 10px;
}
.app .content .mini-loyalty .reward .icon {
  height: 30px;
  width: 30px;
}
.app .content .mini-loyalty .reward .icon.price-tag {
  fill: #7fcf26;
}
.app .content .mini-loyalty .reward .icon.star {
  stroke: #7fcf26;
}
.app .content .mini-loyalty .reward .reward-content {
  margin-left: 10px;
}
.app .content .mini-loyalty .reward .reward-content .title {
  font-size: 0.875rem;
  color: #5a5a5a;
  font-weight: 600;
}
.app .content .mini-loyalty .reward .reward-content .description {
  font-size: 0.75rem;
  color: #88888d;
}
.app .content .loyalty .loyalty-sign-up .text-input {
  flex-grow: 1;
  height: 45px;
  font-size: 1.125rem;
  margin-right: 20px;
}
.app .content .loyalty .loyalty-sign-up .text-input input {
  height: 45px;
  width: 100%;
  padding: 12px;
}
.app .content .loyalty .loyalty-sign-up .button {
  flex-grow: 0;
  font-size: 1rem;
  font-weight: 400;
  width: 141px;
  height: 45px;
  vertical-align: middle;
}
.app .content .loyalty .loyalty-sign-up .email-entry .email-form {
  display: flex;
  flex-wrap: wrap;
}
.app .content .loyalty .loyalty-sign-up .card-entry .card-form {
  display: flex;
  flex-direction: column;
}
.app .content .loyalty .loyalty-sign-up .card-entry .card-form .form.expanded-form.edit-credit-card {
  width: 100%;
}
.app .content .loyalty .loyalty-sign-up .card-entry .card-form .form.expanded-form.edit-credit-card .row {
  align-items: center;
  margin-bottom: 4px;
}
.app .content .loyalty .loyalty-sign-up .card-entry .card-form .form.expanded-form.edit-credit-card .text-input {
  height: auto;
  min-height: 45px;
  flex-direction: column;
  display: flex;
}
.app .content .loyalty .loyalty-sign-up .card-entry .card-form .form.expanded-form.edit-credit-card .text-input .error-text {
  display: block;
  margin-top: 2px;
  margin-bottom: 4px;
  flex-shrink: 0;
}
.app .content .loyalty .loyalty-sign-up .card-entry .card-form .form.expanded-form.edit-credit-card .buttons {
  clear: both;
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
}
.app .content .loyalty .loyalty-sign-up .card-entry .card-form .form.expanded-form.edit-credit-card .buttons .button {
  min-width: 150px;
}
.app .content .loyalty .loyalty-sign-up .card-entry .card-form .button {
  width: 254px;
}
.app .content .loyalty .loyalty-sign-up .card-entry .explanation {
  font-size: 0.875rem;
}
.app .content .loyalty .rewards {
  padding: 22px;
  border-radius: 0 0 5px 5px;
  box-sizing: border-box;
  background-color: #ffffff;
  margin-bottom: 20px;
}
.app .content .loyalty .rewards .reward {
  display: flex;
}
.app .content .loyalty .rewards .reward .reward-photo {
  flex-shrink: 0;
  width: 344px;
  height: 228px;
  margin-right: 22px;
  background-size: cover;
  background-repeat: none;
}
.app .content .loyalty .rewards .reward .reward-content {
  color: #88888d;
}
.app .content .loyalty .rewards .reward .reward-content > * + * {
  margin-top: 12px;
}
.app .content .loyalty .rewards .reward .reward-content .title {
  color: #5a5a5a;
  font-size: 1.45rem;
}
.app .content .loyalty .rewards .reward .reward-content .description {
  font-size: 1.125rem;
  line-height: 1.9em;
}
.app .content .loyalty .rewards .reward .reward-content .highlight {
  font-weight: 700;
}
.app .content .loyalty .rewards .reward + .reward {
  margin-top: 22px;
  padding-top: 22px;
  border-top: 1px solid #ededed;
}
.app .content .loyalty .rewards .reward-progress-bar {
  width: 418px;
  height: 44px;
  margin: 20px 0;
}
.app .content .cart {
  flex-basis: 334px;
  height: 100%;
  min-height: 500px;
  overflow: hidden;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}
.app .content .cart.fixed-cart {
  position: sticky;
  top: 20px;
}
.app .content .cart .ordering-not-available {
  font-weight: 600;
  margin: 0 10%;
}
.app .content .cart .ordering-not-available .icon {
  display: block;
  height: 100px;
  margin: 38px auto;
  width: auto;
}
.app .content .cart .ordering-not-available .message {
  margin-bottom: 20px;
  text-align: center;
}
.app .content .cart .accepting-orders {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
}
.app .content .cart .preorder-wrapper {
  display: flex;
  justify-content: center;
}
.app .content .cart .preorder-wrapper .preorder {
  width: 100%;
}
.app .content .cart .edit-ordering-options {
  padding: 15px;
}
.app .content .cart .edit-ordering-options .order-option {
  padding-bottom: 25px;
}
.app .content .cart .edit-ordering-options .order-option:last-of-type {
  border-bottom: none;
}
.app .content .cart .edit-ordering-options .order-option .title {
  font-weight: 600;
  color: #5a5a5a;
  margin-bottom: 10px;
}
.app .content .cart .edit-ordering-options .order-option .toggle {
  margin: 10px 0;
}
.app .content .cart .edit-ordering-options .order-option .details {
  color: #88888d;
  font-size: 0.75rem;
  font-weight: 400;
}
.app .content .cart .edit-ordering-options .order-option .details .costs {
  float: right;
}
.app .content .cart .edit-ordering-options .order-option .details .costs > * {
  text-align: right;
}
.app .content .cart .edit-ordering-options .order-option .details .costs .value {
  float: right;
  width: 45px;
}
.app .content .cart .edit-ordering-options .order-option .details .estimate {
  display: inline-block;
}
.app .content .cart .edit-ordering-options .cart-prompt {
  margin: 80px auto;
  text-align: center;
  width: 60%;
}
.app .content .cart .edit-ordering-options .button {
  box-sizing: border-box;
  font-size: 0.875rem;
}
.app .content .cart .edit-ordering-options .button.update {
  width: 100%;
  margin-right: 2px;
}
.app .content .cart .edit-ordering-options .delivery-address-container {
  padding-top: 20px;
  position: relative;
}
.app .content .cart .edit-ordering-options .delivery-address-container label {
  display: block;
  margin-bottom: 5px;
  font-size: 0.875rem;
  font-weight: 600;
}
.app .content .cart .edit-ordering-options .delivery-address-container input {
  width: 98%;
  height: 24px;
  padding: 5px 0px 5px 5px;
  margin-top: 5px;
  color: #5a5a5a;
  border-radius: 2px;
  border: 1px solid #ededed;
}
.app .content .cart .edit-ordering-options .delivery-address-container input.invalid {
  border-color: #e02948;
}
.app .content .cart .edit-ordering-options .delivery-address-container .geolocation-container {
  display: none;
}
.app .content .cart .edit-ordering-options .delivery-address-container select {
  color: #5a5a5a;
  border-radius: 2px;
  border: 1px solid #ededed;
  width: 100%;
  height: 30px;
  padding: 5px 0px 5px 5px;
  background: white;
}
.app .content .cart .edit-ordering-options .delivery-address-container .status-message {
  padding-top: 10px;
  white-space: pre;
}
.app .content .cart .edit-ordering-options .delivery-address-container .status-message.valid {
  color: #7fcf26;
}
.app .content .cart .edit-ordering-options .delivery-address-container .status-message.invalid {
  color: #e02948;
}
.app .content .cart .edit-ordering-options .delivery-address-container .address-nag {
  position: relative;
  background: #7fcf26;
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  color: #ffffff;
}
.app .content .cart .edit-ordering-options .delivery-address-container .address-nag:after {
  bottom: 100%;
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-bottom-color: #7fcf26;
  border-width: 10px;
  margin-left: -10px;
}
.app .content .cart .order-time-container {
  padding-top: 20px;
}
.app .content .cart .order-time-container .picker.expanded .options {
  max-height: 225px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.app .content .cart .ordering-options {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  background-color: #445a82;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.app .content .cart .ordering-options .text {
  display: inline-block;
}
.app .content .cart .ordering-options .text .method {
  font-size: 0.875rem;
  font-weight: 400;
}
.app .content .cart .ordering-options .text .details {
  font-size: 0.875rem;
}
.app .content .cart .ordering-options .icon {
  fill: #ffffff;
}
.app .content .cart .items {
  min-height: 285px;
  max-height: calc(100vh - 450px);
  overflow-y: auto;
  flex-grow: 1;
}
.app .content .cart .items .cart-item {
  cursor: pointer;
  padding: 15px 10px;
  position: relative;
  width: auto;
  margin: 0 10px;
  border-bottom: 1px solid #ededed;
  box-sizing: border-box;
  font-size: 1rem;
}
.app .content .cart .items .cart-item > .quantity {
  display: inline-block;
  font-weight: 400;
  vertical-align: top;
  padding-right: 10px;
  color: #212322;
}
.app .content .cart .items .cart-item .details {
  display: inline-block;
  width: 90%;
}
.app .content .cart .items .cart-item .details .name {
  display: inline-block;
  color: #445a82;
  font-weight: 400;
  padding-bottom: 5px;
  max-width: 175px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.app .content .cart .items .cart-item .details .price {
  display: inline-block;
  float: right;
  color: #212322;
  font-weight: 400;
}
.app .content .cart .items .cart-item .details .add-ons {
  margin-bottom: 10px;
}
.app .content .cart .items .cart-item .details .modifier,
.app .content .cart .items .cart-item .details .side {
  font-size: 0.875rem;
  padding-left: 10px;
}
.app .content .cart .items .cart-item .details .instructions {
  font-size: 0.875rem;
  color: #5a5a5a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.app .content .cart .items .cart-item .remove-button {
  position: absolute;
  top: 15px;
  right: 0;
  vertical-align: top;
}
.app .content .cart .items .cart-item .remove-button .icon-wrapper.icon {
  vertical-align: top;
}
.app .content .cart .items .cart-item .remove-button .icon {
  width: 11px;
  height: auto;
  fill: #88888d;
}
.app .content .cart .checkout-summary {
  margin: 10px 0;
}
.app .content .cart .checkout-summary > button {
  margin-bottom: 10px;
}
.app .content .cart .checkout-summary .price-row {
  color: #88888d;
  font-size: 1rem;
  line-height: 20px;
  margin-top: 10px;
}
.app .content .cart .checkout-summary .price-row .title-group {
  display: inline-flex;
  align-items: center;
}
.app .content .cart .checkout-summary .price-row .value {
  float: right;
}
.app .content .cart .checkout-summary .price-row.total {
  color: #212322;
  font-weight: 600;
}
.app .content .cart .accepting-orders .checkout-button-wrapper {
  display: flex;
  justify-content: center;
}
.app .content .cart .accepting-orders .checkout-button-wrapper .checkout-button {
  margin: 20px;
  width: 80%;
}
.app .content .cart .accepting-orders .checkout-button-wrapper .checkout-button.min-not-met {
  height: 66px;
}
.app .content .cart .accepting-orders .checkout-button-wrapper .checkout-button .min-requirement {
  font-size: 0.75rem;
  font-weight: 400;
}
.app .content .cart .cart-change-modal .contents p {
  padding: 0 10px 0 10px;
}
.app .content .cart .cart-change-modal .button {
  width: 80%;
  margin-left: 30px;
}
.app .content .cart .cart-change-modal .confirm-actions {
  margin-bottom: 30px;
  margin-top: 50px;
}
.app .content .cart .items-removed-modal .confirm-actions {
  margin-bottom: 30px;
  margin-top: 50px;
}
.app .content .cart .items-removed-modal .confirm-actions .button {
  display: block;
  width: 100%;
  margin-left: 10px 0;
  height: 50px;
  box-sizing: border-box;
  font-size: 1rem;
  line-height: 50px;
}
.app .content .menu .menu-section {
  box-sizing: border-box;
}
.app .content .menu .menu-section:last-of-type {
  margin-bottom: 20px;
}
.app .content .menu .menu-section h2.name {
  cursor: pointer;
  padding: 20px 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.app .content .menu .menu-section h2.name .icon {
  width: 16px;
  height: auto;
  fill: #445a82;
  margin-right: 12px;
}
.app .content .menu .menu-section .menu-items {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: calc(50% - (20px / 2)) calc(50% - (20px / 2));
  grid-template-rows: 140px;
  overflow: hidden;
}
.app .content .menu .menu-section .menu-items .menu-item {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  box-sizing: border-box;
  background-color: #ffffff;
  cursor: pointer;
  height: 140px;
  line-height: 1.5em;
  display: flex;
}
.app .content .menu .menu-section .menu-items .menu-item.out-of-stock {
  cursor: default;
}
.app .content .menu .menu-section .menu-items .menu-item.out-of-stock .name,
.app .content .menu .menu-section .menu-items .menu-item.out-of-stock .description,
.app .content .menu .menu-section .menu-items .menu-item.out-of-stock .price {
  color: #88888d;
}
.app .content .menu .menu-section .menu-items .menu-item .content-box {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex: 1;
  padding: 10px 15px;
  hyphens: auto;
}
.app .content .menu .menu-section .menu-items .menu-item .name {
  color: #5a5a5a;
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  max-width: 300px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-height: 21px;
  max-height: 21px;
}
.app .content .menu .menu-section .menu-items .menu-item .description {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #5a5a5a;
  flex: 1;
  margin-bottom: 20px;
  padding-right: 10px;
  line-height: 21px;
  max-height: 42px;
  font-size: 0.875rem;
  white-space: pre-wrap;
  overflow-y: auto;
}
.app .content .menu .menu-section .menu-items .menu-item .thumbnail {
  width: 100%;
  height: 100%;
  max-width: 140px;
  max-height: 140px;
}
.app .content .menu .menu-section .menu-items.expanding-enter {
  max-height: 0;
}
.app .content .menu .menu-section .menu-items.expanding-enter.expanding-enter-active {
  transition: max-height 300ms ease-in;
  max-height: 300px;
}
.app .content .menu .menu-section .menu-items.expanding-exit {
  max-height: 300px;
}
.app .content .menu .menu-section .menu-items.expanding-exit.expanding-exit-active {
  transition: max-height 300ms ease-out;
  max-height: 0;
}
.app .content .main-view {
  flex: 1;
  padding-right: 20px;
}
.app .content .main-view .store-description {
  padding: 20px;
  margin: 20px 0;
  white-space: pre-wrap;
}
.app .content .checkout {
  padding: 20px 100px 20px 20px;
  margin-bottom: 20px;
}
.app .content .checkout .delivery-instructions,
.app .content .checkout .curbside-pickup-instructions {
  margin: 10px 0;
  overflow: hidden;
}
.app .content .checkout .delivery-instructions .curbside-pickup-guest-instructions,
.app .content .checkout .curbside-pickup-instructions .curbside-pickup-guest-instructions {
  margin: 10px 0;
}
.app .content .checkout .delivery-instructions label,
.app .content .checkout .curbside-pickup-instructions label {
  color: #5a5a5a;
  font-weight: 600;
  font-size: 0.875rem;
}
.app .content .checkout .delivery-instructions textarea,
.app .content .checkout .curbside-pickup-instructions textarea {
  width: 100%;
  box-sizing: border-box;
  border-color: #e4e4e4;
  border-width: 1px;
  resize: none;
  height: 76px;
  border-radius: 5px;
}
.app .content .checkout .delivery-instructions .length-left,
.app .content .checkout .curbside-pickup-instructions .length-left {
  float: right;
  clear: both;
  font-size: 0.875rem;
  color: #5a5a5a;
}
.app .content .checkout .should-copy {
  padding-left: 120px;
}
.app .content .checkout .submit-button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  text-align: center;
}
.app .content .checkout .submit-button-wrapper .submit-order {
  width: 200px;
}
.app .content .checkout .gratuity {
  margin: 2.5rem 0 1.75rem;
}
.app .content .checkout .gratuity .options {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 78%;
}
.app .content .checkout .gratuity .options .text-input {
  flex-grow: 0;
}
.app .content .checkout .gratuity .gratuity-option {
  border: 1px solid #ededed;
  color: #88888d;
  font-weight: 300;
}
.app .content .checkout .gratuity .gratuity-option.selected {
  border: 1px solid #445a82;
}
.app .content .checkout .gratuity .gratuity-custom {
  border: 1px solid #ededed;
  border-radius: 5px;
  font-size: 0.875rem;
  max-height: 34px;
  padding: 5px;
  position: relative;
}
.app .content .checkout .gratuity .gratuity-custom.selected {
  border: 1px solid #445a82;
}
.app .content .checkout .gratuity .gratuity-custom.selected::before {
  content: "\$";
  color: #88888d;
  position: absolute;
  left: 8px;
  top: calc(5px + 0.6rem);
}
.app .content .checkout .gratuity .gratuity-custom input {
  border: none;
  color: #88888d;
  font-size: inherit;
  font-weight: 300;
  padding: 0;
  text-align: center;
  width: 90px;
}
.app .content .checkout .gratuity .gratuity-custom input:focus {
  outline: none;
}
.app .content .checkout .payment {
  margin: 24px 0;
}
.app .content .checkout .payment .toggle {
  margin: 10px 0;
}
.app .content .checkout .payment.expanding-enter {
  max-height: 0;
}
.app .content .checkout .payment.expanding-enter.expanding-enter-active {
  transition: max-height 300ms ease-in;
  max-height: 415px;
}
.app .content .checkout .payment.expanding-exit {
  max-height: 415px;
}
.app .content .checkout .payment.expanding-exit.expanding-exit-active {
  transition: max-height 300ms ease-out;
  max-height: 0;
}
.app .content .order-error {
  color: #e02948;
  font-weight: 600;
  margin-bottom: 1rem;
}
.app .content .order-error button {
  margin: 10px 0;
}
.app .content .text-input input {
  color: #373737;
}
.app .content .item-modal {
  cursor: default;
  overflow: hidden;
  width: 600px;
  -webkit-touch-callout: auto;
  -webkit-user-select: auto;
  -moz-user-select: auto;
  user-select: auto;
}
.app .content .item-modal .modal-content {
  padding: 20px;
  max-height: 60vh;
  overflow-y: scroll;
}
.app .content .item-modal .modal-content .description-full {
  color: #5a5a5a;
  font-size: 0.875rem;
  line-height: 21px;
  margin-top: 10px;
  margin-bottom: 20px;
  white-space: pre-wrap;
}
.app .content .item-modal .modal-content .item-image-container {
  position: relative;
  height: 300px;
  width: 100%;
  overflow: hidden;
}
.app .content .item-modal .modal-content .item-image-container .item-background-overlay {
  background-position: left;
  background-size: 100%;
  background-repeat: no-repeat;
  height: 300px;
  z-index: 1;
  -moz-filter: blur(3px);
  -o-filter: blur(3px);
  -ms-filter: blur(3px);
  filter: blur(3px);
}
.app .content .item-modal .modal-content .item-image-container .item-blurred-background {
  position: absolute;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
  height: 300px;
  width: 100%;
  z-index: 2;
}
.app .content .item-modal .modal-content .item-image-container .item-image-main {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: block;
  height: 300px;
  margin: 0 auto;
  z-index: 5;
}
.app .content .item-modal .modal-content .section {
  margin-bottom: 25px;
}
.app .content .item-modal .modal-content .section .title {
  font-weight: 600;
  color: #5a5a5a;
}
.app .content .item-modal .modal-content .instructions-input {
  padding: 10px;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #ededed;
  font-size: 0.875rem;
  height: 90px;
  margin-top: 10px;
  resize: none;
  width: 100%;
}
.app .content .item-modal .modal-content .instructions-input:-moz-placeholder {
  color: #88888d;
}
.app .content .item-modal .modal-content .instructions-input:placeholder-shown {
  color: #88888d;
}
.app .content .item-modal .modal-content .quantity-wrapper {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.app .content .item-modal .modal-content .quantity-wrapper .quantity-selector {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.app .content .item-modal .modal-content .quantity-wrapper .quantity-selector .quantity-value {
  color: #88888d;
  display: inline-block;
  font-size: 1.45rem;
  position: relative;
  top: 4px;
  width: 38px;
  text-align: center;
}
.app .content .item-modal .modal-content .quantity-wrapper .quantity-selector .quantity-value:focus {
  outline: none;
}
.app .content .item-modal .modal-content .quantity-wrapper .quantity-selector .increment,
.app .content .item-modal .modal-content .quantity-wrapper .quantity-selector .decrement {
  background: transparent;
  border-radius: 5px;
  border: 1px solid #445a82;
  color: #445a82;
  cursor: pointer;
  display: inline-block;
  font-size: 1.875rem;
  height: 38px;
  line-height: 38px;
  padding: 0;
  text-align: center;
  vertical-align: middle;
  width: 38px;
}
.app .content .item-modal .modal-content .quantity-wrapper .quantity-selector .increment:disabled,
.app .content .item-modal .modal-content .quantity-wrapper .quantity-selector .decrement:disabled {
  cursor: not-allowed;
  opacity: 0.3;
}
.app .content .item-modal .modal-content .quantity-wrapper .quantity-selector .decrement {
  line-height: 35px;
}
.app .content .item-modal .modal-content .quantity-wrapper .quantity-info {
  margin-left: 10px;
  font-size: 1rem;
  color: #5a5a5a;
}
.app .content .item-modal .modal-content .modifier-section .section-title,
.app .content .item-modal .modal-content .side-section .section-title {
  align-items: baseline;
  display: flex;
  margin-bottom: 10px;
}
.app .content .item-modal .modal-content .modifier-section .section-title .restrictions,
.app .content .item-modal .modal-content .side-section .section-title .restrictions {
  font-size: 0.875rem;
  margin-left: 10px;
}
.app .content .item-modal .modal-content .modifier-section .section-title .required,
.app .content .item-modal .modal-content .side-section .section-title .required {
  color: #e02948;
}
.app .content .item-modal .modal-content .modifier-section .section-title .max-reached,
.app .content .item-modal .modal-content .side-section .section-title .max-reached {
  color: #7fcf26;
  font-size: 0.875rem;
  margin-left: auto;
}
.app .content .item-modal .modal-content .modifier-section .options,
.app .content .item-modal .modal-content .side-section .options {
  color: #5a5a5a;
  display: flex;
  flex-flow: row wrap;
  flex-basis: 100%;
  padding: 0 10px;
}
.app .content .item-modal .modal-content .modifier-section .options .modifier,
.app .content .item-modal .modal-content .side-section .options .modifier,
.app .content .item-modal .modal-content .modifier-section .options .side,
.app .content .item-modal .modal-content .side-section .options .side {
  flex-basis: 33%;
  font-size: 0.875rem;
  font-weight: 400;
  margin-bottom: 10px;
}
.app .content .item-modal .modal-content .modifier-section .options .side-price,
.app .content .item-modal .modal-content .side-section .options .side-price,
.app .content .item-modal .modal-content .modifier-section .options .mod-price,
.app .content .item-modal .modal-content .side-section .options .mod-price {
  color: #5a5a5a;
}
.app .content .item-modal .item-modal-footer {
  height: 68px;
  padding: 14px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f5f5;
}
.app .content .item-modal .item-modal-footer .subtotal {
  color: #5a5a5a;
  font-size: 1.25rem;
  font-weight: 400;
}
.app .content .tooltip {
  display: inline-block;
  margin-left: 5px;
  vertical-align: middle;
}
.app .content .tooltip .tooltip-icon-wrapper {
  height: 20px;
  width: 20px;
  outline: none;
}
.app .order-confirm-modal {
  padding: 20px;
  text-align: center;
  width: 60vw;
  min-height: 170px;
}
.app .order-confirm-modal .close .icon {
  top: 5px;
}
.app .order-confirm-modal .check-icon {
  height: 150px;
  margin: 20px auto;
  width: auto;
}
.app .order-confirm-modal .delivery-address {
  font-size: 1.25rem;
  margin-top: 20px;
}
.app .order-confirm-modal .delivery-address .customer-name,
.app .order-confirm-modal .delivery-address .customer-address {
  color: #5a5a5a;
  font-weight: 400;
}
.app .order-confirm-modal .store-address {
  font-size: 1.25rem;
}
.app .order-confirm-modal .store-phone {
  color: #445a82;
  font-size: 1.25rem;
  margin-bottom: 20px;
}
.app .order-confirm-modal .order-payment-method {
  border-bottom: 1px solid #ededed;
  font-size: 0.875rem;
  padding: 20px;
}
.app .order-confirm-modal .email-message {
  margin: 0 auto 20px;
  width: 80%;
}
.app .order-confirm-modal .email-message .email {
  color: #445a82;
}
.app .order-confirm-modal .order-number {
  font-weight: 400;
  margin-bottom: 10px;
}
.app .order-confirm-modal .indicator {
  top: -100px;
}
.app.account .back-button {
  display: inline-block;
  margin: 12px 5px;
}
.app.account .form {
  max-width: 540px;
}
.app.account .expanded-form {
  background-color: #f5f5f5;
  border-radius: 5px;
  margin: 0 0 20px -10px;
  padding: 20px 20px 20px 20px;
  overflow: hidden;
}
.app.account .buttons {
  clear: both;
  display: flex;
  justify-content: flex-end;
}
.app.account .buttons .button {
  margin-left: 5px;
  min-width: 150px;
}
.app.account .account-settings {
  width: 100%;
  padding: 14px;
  box-sizing: border-box;
}
.app.account .account-settings .account-section {
  padding: 6px 24px;
  border-top: 1px solid #ededed;
}
@keyframes fade {
  0% {
    opacity: 1;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.app.account .account-settings .contact-info .updated-text {
  display: inline-block;
  width: 56px;
  margin-left: 10px;
  font-size: 0.875rem;
  color: #7fcf26;
  opacity: 0;
  animation: fade 3s ease-in;
}
.app.account .account-settings .contact-info .name .text-input + .text-input {
  margin-left: 12px;
}
.app.account .account-settings .password {
  border-top: 1px solid #ededed;
}
.app.account .account-settings .password .title {
  display: inline-block;
}
.app.account .account-settings .password .edit-button {
  display: inline-block;
  margin-left: 30px;
}
.app.account .address-list-wrapper {
  border-top: 1px solid #ededed;
}
.app.account .address-list-wrapper .address-list {
  padding-left: 12px;
}
.app.account .address-list-wrapper .address {
  margin: 15px 0;
}
.app.account .address-list-wrapper .address .actions {
  display: inline-block;
}
.app.account .address-list-wrapper .address .actions .update {
  cursor: pointer;
}
.app.account .address-list-wrapper .address .actions .update.edit {
  border-right: 1px solid #ededed;
  margin-left: 20px;
  padding-right: 10px;
  color: #445a82;
}
.app.account .address-list-wrapper .address .actions .update.remove {
  color: #e02948;
  margin-left: 10px;
}
.app.account .card-list-wrapper .credit-card .card-icon {
  width: 3em;
}
.app.account .card-list-wrapper .credit-card .actions .update {
  cursor: pointer;
}
.app.account .card-list-wrapper .credit-card .actions .update.remove {
  color: #e02948;
}
.app.account .order-history {
  border-top: 1px solid #ededed;
}
.app.account .order-history .order-history-table {
  width: 100%;
}
.app.account .order-history .order-history-table th,
.app.account .order-history .order-history-table td {
  padding-right: 24px;
  text-align: center;
}
.app.account .order-history .order-history-table th.date,
.app.account .order-history .order-history-table td.date {
  text-align: left;
}
.app.account .order-history .order-history-table td {
  border-top: 1px solid #ededed;
  white-space: nowrap;
}
.app.account .order-history .order-history-table td.date {
  font-weight: 400;
}
.app.account .order-history .order-history-table td.space-fill {
  width: 100%;
}
.app .icon-wrapper {
  line-height: 0;
}
@media (max-width: 1024px) {
  .modal {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: auto;
    height: auto;
    transform: none;
    border-radius: 0;
  }
  .modal header .title {
    display: none;
  }
  .modal header .mobile-title {
    display: block;
    color: #5a5a5a;
    font-size: 1.25rem;
  }
  .picker {
    width: 100%;
  }
  .alert-modal .contents {
    width: auto;
    padding: 0 18px;
    text-align: left;
  }
  .confirm-modal .contents .confirm-actions {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
  }
  .confirm-modal .contents .confirm-actions .button {
    width: 100%;
    margin-bottom: 10px;
    flex-basis: 100%;
    flex-shrink: 0;
    margin-left: 0;
    box-sizing: border-box;
  }
  .confirm-modal .contents .confirm-actions .button.confirm {
    order: 1;
  }
  .confirm-modal .contents .confirm-actions .button.cancel {
    order: 2;
  }
  .form {
    width: 100%;
  }
  .form .row {
    flex-direction: column;
    align-items: stretch;
  }
  .form .row .multi-field {
    margin-left: 0;
  }
  .form .row .label,
  .form .row label {
    margin: 0 0 5px 0;
  }
  .form .row label.cvv,
  .form .row label.zip {
    margin: 13px 4px 5px 0;
  }
  .form .row .expiry-divider {
    display: none;
  }
  .text-input input {
    font-size: 1.25rem;
  }
  .text-input input.exp {
    max-height: 42px;
  }
  .preview-banner {
    height: 100%;
    padding: 10px 0;
  }
  .preview-banner .inner {
    width: 100%;
    flex-direction: column;
  }
  .preview-banner .inner .right {
    align-self: flex-start;
  }
  .preview-banner a {
    text-decoration: underline;
  }
  .app {
    width: 100%;
  }
  .app .header {
    background-position: center;
    padding: 15px 20px;
  }
  .app .header .location-name {
    font-size: 1.45rem;
  }
  .app .header .login {
    align-self: flex-start;
    color: #ffffff;
  }
  .app .header .login .text,
  .app .header .login .separator,
  .app .header .login .address-spacer {
    display: none;
  }
  .app .header .login .icon.user {
    width: 20px;
    height: 20px;
  }
  .app .header .hide-on-mobile {
    display: none;
  }
  .app .header .login-modal .contents {
    width: auto;
    padding: 0 18px;
  }
  .app .header .reset-password-modal .contents {
    width: auto;
    padding: 0 18px;
    text-align: left;
  }
  .app .footer {
    width: 100%;
    height: 70px;
    text-align: center;
    visibility: hidden;
  }
  .app .footer .separator,
  .app .footer .outside-reference {
    display: none;
  }
  .app .footer .upserve {
    font-size: 1.125rem;
    font-weight: 400;
    width: 100%;
  }
  .app .footer .upserve .powered {
    color: #212322;
  }
  .app .footer .upserve .logo-icon {
    height: 25px;
    width: auto;
    position: relative;
    top: 2px;
    left: 4px;
  }
  .app .content {
    width: 95vw;
    margin: 0 auto;
  }
  .app .content .loyalty {
    width: 100%;
  }
  .app .content .loyalty .rewards {
    width: 100%;
  }
  .app .content .loyalty .rewards .reward .reward-photo {
    display: none;
  }
  .app .content .loyalty .rewards .reward-progress-bar {
    width: 100%;
  }
  .app .content .loyalty .loyalty-sign-up .email-entry .email-form,
  .app .content .loyalty .loyalty-sign-up .card-entry .email-form,
  .app .content .loyalty .loyalty-sign-up .email-entry .card-form,
  .app .content .loyalty .loyalty-sign-up .card-entry .card-form {
    flex-wrap: wrap;
  }
  .app .content .loyalty .loyalty-sign-up .email-entry .email-form .text-input,
  .app .content .loyalty .loyalty-sign-up .card-entry .email-form .text-input,
  .app .content .loyalty .loyalty-sign-up .email-entry .card-form .text-input,
  .app .content .loyalty .loyalty-sign-up .card-entry .card-form .text-input {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .app .content .loyalty .loyalty-sign-up .email-entry .email-form .button,
  .app .content .loyalty .loyalty-sign-up .card-entry .email-form .button,
  .app .content .loyalty .loyalty-sign-up .email-entry .card-form .button,
  .app .content .loyalty .loyalty-sign-up .card-entry .card-form .button {
    width: 100%;
  }
  .app .content .loyalty .location-info .lower {
    flex-wrap: wrap;
  }
  .app .content .location-info {
    margin-bottom: 20px;
  }
  .app .content .location-info .lower {
    flex-direction: column;
    align-items: center;
  }
  .app .content .location-info .address-column,
  .app .content .location-info .promo-description {
    width: 300px;
  }
  .app .content .location-info .promo-description {
    margin: 0 auto;
  }
  .app .content .address-list-wrapper .address .actions {
    display: block;
  }
  .app .content .address-list-wrapper .address .actions .update.edit {
    margin-left: 0 ;
  }
  .app .content .menu .menu-section {
    padding: 10px 0 0;
    width: 93vw;
  }
  .app .content .menu .menu-section:last-of-type {
    margin-bottom: 20px;
  }
  .app .content .menu .menu-section .menu-items {
    grid-template-columns: 100%;
  }
  .app .content .main-view {
    padding: 0;
    width: 100%;
  }
  .app .content .cart {
    flex-basis: 100%;
    order: -1;
    min-height: 0;
  }
  .app .content .cart.fixed-cart {
    position: static;
    margin-bottom: 40px;
  }
  .app .content .cart .ordering-not-available {
    margin-top: 0;
  }
  .app .content .cart .edit-ordering-options .cart-prompt {
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .app .content .cart .edit-ordering-options .delivery-address-container input {
    width: 88%;
    padding: 5px 0px 5px 35px;
  }
  .app .content .cart .edit-ordering-options .delivery-address-container .geolocation-container {
    display: unset;
  }
  .app .content .cart .edit-ordering-options .delivery-address-container .icon .geolocation {
    position: relative;
    left: 0;
    top: 48px;
    padding: 9px 8px;
  }
  .app .content .cart .accepting-orders .checkout-button-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
  }
  .app .content .item-modal {
    width: 100vw;
  }
  .app .content .item-modal .modal-content {
    height: 100%;
    padding-bottom: 130px;
  }
  .app .content .item-modal .modal-content .modifier-section .section-title,
  .app .content .item-modal .modal-content .side-section .section-title {
    flex-direction: column;
  }
  .app .content .item-modal .modal-content .modifier-section .section-title .restrictions,
  .app .content .item-modal .modal-content .side-section .section-title .restrictions {
    margin-left: 0;
  }
  .app .content .item-modal .modal-content .modifier-section .section-title .required,
  .app .content .item-modal .modal-content .side-section .section-title .required {
    color: #e02948;
  }
  .app .content .item-modal .modal-content .modifier-section .section-title .max-reached,
  .app .content .item-modal .modal-content .side-section .section-title .max-reached {
    margin-left: 0;
  }
  .app .content .item-modal .modal-content .modifier-section .options,
  .app .content .item-modal .modal-content .side-section .options {
    flex-flow: column nowrap;
    padding: 0;
  }
  .app .content .item-modal .modal-content .modifier-section .options .modifier,
  .app .content .item-modal .modal-content .side-section .options .modifier,
  .app .content .item-modal .modal-content .modifier-section .options .side,
  .app .content .item-modal .modal-content .side-section .options .side {
    flex-basis: 0;
  }
  .app .content .item-modal .item-modal-footer {
    bottom: 0;
    position: fixed;
    width: 100%;
  }
  .app .content .checkout {
    padding-right: 20px;
  }
  .app .content .checkout .should-copy {
    padding-left: 0;
  }
  .app .content .checkout .submit-order {
    width: 90%;
    align-self: center;
    margin-top: 10px;
  }
  .app .content .checkout .payment .credit-card-picker {
    margin-top: 24px;
  }
  .app .content .checkout .payment .new-credit-card-form label.cvv,
  .app .content .checkout .payment .new-credit-card-form label.zip {
    margin: 13px 4px 5px 0;
  }
  .app .content .checkout .payment .new-credit-card-form .expiry-divider {
    display: none;
  }
  .app .content .checkout .gratuity .options {
    width: 100%;
  }
  .app .content .checkout .gratuity .gratuity-option {
    padding-left: 3vw;
    padding-right: 3vw;
  }
  .app .content .order-confirm-modal {
    padding: 10px;
    width: calc(100vw - 20px);
  }
  .app .content .cart .items {
    height: auto;
  }
  .app.account .buttons {
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .app.account .buttons .button {
    margin-bottom: 10px;
    max-width: none;
  }
  .app.account .content {
    padding: 0;
  }
  .app.account .content .account-settings .contact-info {
    width: auto;
  }
  .app.account .content .account-settings .contact-info .name .text-input + .text-input {
    margin-left: 0;
    margin-top: 10px;
  }
}
.pac-container:after {
  /* Disclaimer: not needed to show 'powered by Google' if also a Google Map is shown */
  background-image: none !important;
  height: 0px;
}
#portal-root .tooltip-portal {
  line-height: 1.5;
  position: fixed;
}
#portal-root .tooltip-portal .triangle {
  background-color: #ffffff;
  border-bottom: 1px #88888d solid;
  border-left: 1px solid #88888d;
  border-top: 1px transparent solid;
  bottom: -8px;
  height: 16px;
  position: absolute;
  width: 16px;
  z-index: 11;
}
#portal-root .tooltip-portal.positionRight .triangle {
  left: 17px;
  transform: rotateY(0deg) rotate(45deg);
}
#portal-root .tooltip-portal.positionLeft .triangle {
  right: 17px;
  transform: rotateY(0deg) rotate(225deg);
}
#portal-root .tooltip-portal .content {
  background-color: #ffffff;
  border-radius: 5px;
  border: 1px #88888d solid;
  height: auto;
  max-height: 300px;
  padding: 16px;
  position: absolute;
  transform: translateY(-50%);
  width: 250px;
  z-index: 10;
}
#portal-root .tooltip-portal .content.isNarrow {
  width: 150px;
}
#portal-root .tooltip-portal .content dd,
#portal-root .tooltip-portal .content dt {
  color: #212322;
}
#portal-root .tooltip-portal .content #asterisk {
  color: #5a5a5a;
  margin-bottom: 5px;
}
#portal-root .tooltip-portal.positionRight .content {
  left: 25px;
}
#portal-root .tooltip-portal.positionLeft .content {
  right: 25px;
}
`, "",{"version":3,"sources":["webpack://./styles/fonts.less","webpack://./styles/app.less","webpack://./styles/icon.less","webpack://./styles/button.less","webpack://./styles/mixins.less","webpack://./styles/checkbox.less","webpack://./styles/forms.less","webpack://./styles/toggle.less","webpack://./styles/picker.less","webpack://./styles/loader.less","webpack://./styles/overlay.less","webpack://./styles/modal.less","webpack://./styles/alert_modal.less","webpack://./styles/confirm_modal.less","webpack://./styles/online_ordering/preview_banner.less","webpack://./styles/header.less","webpack://./styles/auth_modal.less","webpack://./styles/authentication/sent_modal.less","webpack://./styles/footer.less","webpack://./styles/location_info.less","webpack://./styles/loyalty/reward_progress_bar.less","webpack://./styles/loyalty/mini_loyalty.less","webpack://./styles/loyalty/sign_up.less","webpack://./styles/loyalty.less","webpack://./styles/online_ordering/cart.less","webpack://./styles/online_ordering/cart/edit_ordering_options.less","webpack://./styles/online_ordering/cart/ordering_options.less","webpack://./styles/online_ordering/cart/items.less","webpack://./styles/online_ordering/cart/checkout_summary.less","webpack://./styles/online_ordering/cart/accepting_orders.less","webpack://./styles/online_ordering/cart/cart_change_modal.less","webpack://./styles/online_ordering/cart/items_removed_modal.less","webpack://./styles/online_ordering/menu.less","webpack://./styles/online_ordering/menu/menu_items.less","webpack://./styles/online_ordering/main_view.less","webpack://./styles/online_ordering/checkout.less","webpack://./styles/online_ordering/checkout/gratuity.less","webpack://./styles/online_ordering/checkout/payment.less","webpack://./styles/online_ordering/item_modal.less","webpack://./styles/online_ordering/item_modal/quantity_selector.less","webpack://./styles/online_ordering/item_modal/modifier_section.less","webpack://./styles/online_ordering/tooltip.less","webpack://./styles/online_ordering/checkout/order_confirm_modal.less","webpack://./styles/account.less","webpack://./styles/account/contact_info.less","webpack://./styles/account/password.less","webpack://./styles/account/addresses.less","webpack://./styles/account/address.less","webpack://./styles/account/credit_card.less","webpack://./styles/account/order_history.less","webpack://./styles/mobile/modal.less","webpack://./styles/mobile/picker.less","webpack://./styles/mobile/alert_modal.less","webpack://./styles/mobile/confirm_modal.less","webpack://./styles/mobile/forms.less","webpack://./styles/mobile/online_ordering/preview_banner.less","webpack://./styles/mobile.less","webpack://./styles/mobile/header.less","webpack://./styles/mobile/footer.less","webpack://./styles/mobile/loyalty.less","webpack://./styles/mobile/location_info.less","webpack://./styles/mobile/account/address.less","webpack://./styles/mobile/online_ordering/menu.less","webpack://./styles/mobile/online_ordering/menu/menu_items.less","webpack://./styles/mobile/online_ordering/main_view.less","webpack://./styles/mobile/online_ordering/cart.less","webpack://./styles/mobile/online_ordering/cart/edit_ordering_options.less","webpack://./styles/mobile/online_ordering/cart/accepting_orders.less","webpack://./styles/mobile/online_ordering/item_modal.less","webpack://./styles/mobile/online_ordering/item_modal/modifier_section.less","webpack://./styles/mobile/online_ordering/checkout.less","webpack://./styles/mobile/online_ordering/checkout/payment.less","webpack://./styles/mobile/online_ordering/checkout/gratuity.less","webpack://./styles/mobile/online_ordering/checkout/order_confirm_modal.less","webpack://./styles/mobile/online_ordering/cart/items.less","webpack://./styles/mobile/account.less","webpack://./styles/portal-tooltip.less"],"names":[],"mappings":"AAOA;EACE,sBAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;ACPF;ADUA;EACE,sBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;ACRF;ACjBA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;ADmBF;ACjBE;EACE,UAAA;ADmBJ;AChBE;EACE,WAAA;EACA,YAAA;ADkBJ;ACdA;EACE,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;ADgBF;AEvCA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;ECQA,yCAAA;EAUA,2BAAA;EACA,yBAAA;EAEA,sBAAA;EACA,iBAAA;AH2BF;AE/CE;EACE,gBAAA;EACA,yBAAA;AFiDJ;AE9CE;EACE,mBAAA;EACA,gBAAA;AFgDJ;AE7CE;EACE,eAAA;EACA,gBAAA;AF+CJ;AE5CE;EACE,mBAAA;AF8CJ;AEzCE;EACE,cAAA;EACA,SAAA;AF2CJ;AExCE;EACE,gBAAA;AF0CJ;AErCE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AFuCJ;AErCI;EACE,yBAAA;AFuCN;AEnCE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AFqCJ;AElCE;EACE,cAAA;AFoCJ;AElCI;EACE,yBAAA;AFoCN;AIlGA;EACE,qBAAA;EACA,kBAAA;AJoGF;AItGA;EAKI,cAAA;EACA,eAAA;AJoGJ;AInGI;EACE,aAAA;EACA,eAAA;AJqGN;AI9GA;EAcI,SAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AJmGJ;AI/FA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;AJiGF;AI9FA;EACE,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;AJgGF;AI9FE;EACE,yBAAA;EACA,kBAAA;EACA,QAAA;AJgGJ;AInGE;EAMI,qBAAA;AJgGN;AI5FE;EACE,eAAA;EACA,aAAA;EACA,qBAAA;AJ8FJ;AKjJA;EAEI,cAAA;EACA,aAAA;EACA,mBAAA;ALkJJ;AKhJI;EACE,aAAA;ALkJN;AKzJA;EAWM,aAAA;EACA,YAAA;EACA,SAAA;ALiJN;AK9JA;;;EAiBM,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;ALkJN;AKvKA;;EAyBM,iBAAA;EACA,iBAAA;ALkJN;AK5KA;;EA+BM,cAAA;ALiJN;AK9II;EAAA;;IAEI,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,WAAA;ELiJN;AACF;AKzLA;EA4CM,kBAAA;ALgJN;AK5LA;EAgDM,YAAA;EACA,cAAA;AL+IN;AK1IA;EAEI,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AL2IJ;AKzII;EACE,gBAAA;AL2IN;AKvIE;EAEI,yBAAA;ALwIN;AK1IE;EAMI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;ALuIN;AKlIA;EACE,YAAA;ALoIF;AKrIA;EAII,cAAA;EACA,cAAA;EACA,iBAAA;ALoIJ;AK1IA;EAUI,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;ALmIJ;AKhIE;EACE,qBAAA;ALkIJ;AK/HE;EACE,yBAAA;ALiIJ;AM9OA;EACE,aAAA;ANgPF;AMjPA;EAII,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;ANgPJ;AM9OI;EACE,cAAA;EACA,qBAAA;ANgPN;AO9PA;EACE,qBAAA;EACA,WAAA;EACA,yBAAA;APgQF;AO9PE;EAEI,YAAA;EACA,yBAAA;AP+PN;AO5PQ;EACE,WAAA;AP8PV;AO/PQ;EAGI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AP+PZ;AOrQQ;EASM,eAAA;AP+Pd;AO1PQ;EACE,6BAAA;EACA,gBAAA;EACA,WAAA;AP4PV;AOxRA;EAmCI,eAAA;EACA,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;APwPJ;AOhSA;EA4CQ,aAAA;APuPR;AOnSA;EAiDM,kBAAA;EACA,SAAA;EACA,WAAA;APqPN;AOxSA;EAuDM,WAAA;EACA,YAAA;EACA,aAAA;APoPN;AO/OE;EAEI,qBAAA;APgPN;AOhTA;EAqEI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AP8OJ;AOtTA;EA4EI,kBAAA;EACA,eAAA;EJpEF,0CAAA;AHoTF;AO7TA;EAkFI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AP8OJ;AQ/TA;EACE;IAAQ,uBAAA;ERkVR;EQjVA;IAAQ,yBAAA;ERoVR;AACF;AQlVA;EACE,kBAAA;ARoVF;AQrVA;EAII,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;ARoVJ;AQ7VA;EAYM,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,mDAAA;EACA,sBAAA;ARoVN;AQjVI;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;EL1BJ,kCAAA;AH+WF;AQhVE;EAGM,OAAA;ARgVR;AQ9UM;EACE,OAAA;ARgVR;AS1YA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,iCAAA;ENQA,oCAAA;AHuYF;AUtZA;EACE,eAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EPFA,2CAAA;EANA,2BAAA;AHsaF;AUzaA;EAgBI,YAAA;AV4ZJ;AU5aA;EAmBM,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AV4ZN;AUlbA;EA0BM,aAAA;EACA,WAAA;EACA,YAAA;AV2ZN;AUvbA;EAiCI,kBAAA;EACA,gCAAA;AVyZJ;AU3bA;EAqCM,cAAA;EACA,kBAAA;EACA,aAAA;AVyZN;AUhcA;EA4CI,YAAA;AVuZJ;AUncA;EA+CM,mBAAA;AVuZN;AUtcA;EAoDI,YAAA;EACA,kBAAA;EACA,6BAAA;AVqZJ;AU3cA;EAyDM,cAAA;AVqZN;AU9cA;EA4DQ,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AVqZR;AWpdA;EAEI,kBAAA;EACA,YAAA;EACA,iBAAA;AXqdJ;AWzdA;EAOM,WAAA;EACA,sBAAA;AXqdN;AY7dA;EAEI,iBAAA;AZ8dJ;AYheA;EAKM,gBAAA;EACA,YAAA;AZ8dN;AapeA;EACE,yBAAA;EACA,cAAA;EACA,aAAA;AbseF;AazeA;EAMI,uBAAA;AbseJ;Aa5eA;EAUI,0BAAA;AbqeJ;Aa/eA;EAcI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;AboeJ;AaxfA;EAuBM,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AboeN;Aa9fA;EA6BQ,cAAA;AboeR;AajgBA;EAgCU,gBAAA;AboeV;AapgBA;EAqCQ,cAAA;AbkeR;AavgBA;EA0CM,kBAAA;EACA,kBAAA;AbgeN;Aa3gBA;EA8CQ,yBAAA;EACA,iBAAA;AbgeR;Aa/gBA;EAqDI,aAAA;EACA,cAAA;Ab6dJ;AanhBA;EAyDM,mBAAA;Ab6dN;AathBA;EA6DM,cAAA;EACA,UAAA;Ab4dN;Aa1hBA;EAkEM,YAAA;EACA,aAAA;Ab2dN;Aa9hBA;EAuEM,aAAA;EACA,mBAAA;EACA,sBAAA;Ab0dN;AA/fA;EACE,YAAA;EAMA,gBAAA;AA4fF;AAzfA;EACE,SAAA;EACA,YAAA;AA2fF;AAxfA;EACE,YAAA;AA0fF;AAvfA;;EAEE,cAAA;EACA,gBAAA;AAyfF;AAtfA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAwfF;AArfA;EACE,mBAAA;AAufF;AApfA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAsfF;AAnfA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAqfF;AAlfA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AAofF;AAjfA;EACE,mBAAA;EACA,yBAAA;AAmfF;AArfA;EAKI,gBAAA;EACA,sBAAA;AAmfJ;AAzfA;EAUI,uBAAA;AAkfJ;AA9eA;EACE,kCAAA;AAgfF;AA7eA;EACE,kCAAA;AA+eF;AA5eA;EACE,gBAAA;EACA,eAAA;AA8eF;AA3eA;EACE,gBAAA;AA6eF;AA1eA;EACE,gBAAA;AA4eF;AAzeA;EACE,eAAA;AA2eF;AAteA;EACE,wBAAA;AAweF;AAreA;EACE,YAAA;EACA,aAAA;AAueF;AApeA;EACE,kBAAA;AAseF;AAveA;EAII,YAAA;EACA,aAAA;EACA,sBAAA;AAseJ;AAjeA;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;AAmeF;AAheA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAkeF;AAxeA;EchKE,aAAA;EACA,0BAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,6CAAA;Ad2oBF;AAlfA;EctJI,YAAA;Ad2oBJ;AArfA;EcnJM,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EAGA,6BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;AdyoBN;AAlgBA;EcnIM,eAAA;EACA,iBAAA;AdwoBN;AAtgBA;;Ec7HM,gBAAA;EACA,mBAAA;EACA,uBAAA;AduoBN;AA5gBA;;EcxHQ,cAAA;AdwoBR;AAhhBA;;EcpHQ,cAAA;AdwoBR;AAphBA;Ec9GI,aAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;AdqoBJ;AA5hBA;EctGM,YAAA;AdqoBN;AA/hBA;EchGM,iBAAA;AdkoBN;AAliBA;;Ec3FM,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AdioBN;AAziBA;EehKE,iBAAA;Af4sBF;AA5iBA;Ee7JI,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;Af4sBJ;AAnjBA;EetJM,kBAAA;Af4sBN;AAtjBA;EelJM,eAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;Af2sBN;AA7jBA;EezII,cAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AfysBJ;AApkBA;EelIM,mBAAA;AfysBN;AetsBI;EACE,aAAA;AfwsBN;AezsBI;EAII,UAAA;AfwsBR;AA7kBA;EetHM,YAAA;EACA,aAAA;AfssBN;AAjlBA;;;;Ee9GM,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;AfqsBN;AA5lBA;;;EenGM,cAAA;EACA,gBAAA;EACA,cAAA;AfosBN;AAnmBA;Ee5FI,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;AfksBJ;AA/mBA;EehFM,WAAA;EACA,YAAA;AfksBN;AAnnBA;Ee1EI,cAAA;EACA,eAAA;EACA,YAAA;AfgsBJ;AAxnBA;EerEM,WAAA;EACA,YAAA;AfgsBN;AA5nBA;EehEM,cAAA;EACA,0BAAA;Af+rBN;AAhoBA;EgB/JI,iBAAA;AhBkyBJ;AAnoBA;EgB5JM,gBAAA;AhBkyBN;AAtoBA;EiBhKE,yBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EdAA,wCAAA;EcEA,mBAAA;AjB2yBF;AArpBA;EiBnJI,YAAA;EACA,gBAAA;EACA,eAAA;AjB2yBJ;AA1pBA;EiB/IM,YAAA;EACA,cAAA;AjB4yBN;AA9pBA;EiBzII,cAAA;EACA,wBAAA;EAAA,mBAAA;AjB0yBJ;AAlqBA;EiBrIM,cAAA;EACA,cAAA;AjB0yBN;AAtqBA;EiBhIM,YAAA;AjByyBN;AAzqBA;EkBhKE,aAAA;EACA,mBAAA;AlB40BF;AA7qBA;EkB5JI,mBAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,oBAAA;AlB40BJ;AAprBA;EkBpJI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;AlB20BJ;AA1rBA;EkB9IM,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AlB20BN;AAlsBA;EkBtIQ,gBAAA;AlB20BR;AArsBA;EkBnIU,cAAA;AlB20BV;AAxsBA;EAaI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;AA8rBJ;AA/sBA;EAoBM,gBAAA;AA8rBN;AA3rBI;EACE,UAAA;AA6rBN;AArtBA;EA4BM,yBAAA;EACA,kBAAA;EGrLJ,0CAAA;AHo3BF;AA5rBM;EACE,mBAAA;AA8rBR;AA/tBA;EAqCM,eAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AA6rBN;AAvuBA;EA6CQ,cAAA;EACA,YAAA;EACA,WAAA;AA6rBR;AA5uBA;EAmDQ,kBAAA;AA4rBR;AA/uBA;EAuDQ,gBAAA;AA2rBR;AAlvBA;EmBhKE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AnBq5BF;AAzvBA;EmBzJI,aAAA;EACA,cAAA;AnBq5BJ;AA7vBA;EmBpJI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AnBo5BJ;AArwBA;EmB5IM,qBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;AnBo5BN;AA5wBA;EoBhKE,WAAA;ApB+6BF;AA/wBA;EoB7JI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;ApB+6BJ;AoB76BI;EAEI,aAAA;EACA,YAAA;EACA,8BAAA;ApB86BR;AoBl7BI;EAOM,mBAAA;EACA,cAAA;EACA,cAAA;ApB86BV;AoBv7BI;EAaM,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,YAAA;ApB66BV;AAvyBA;EoBhIM,YAAA;ApB06BN;AA1yBA;EoB5HM,YAAA;EACA,WAAA;ApBy6BN;AoBv6BM;EACE,aAAA;ApBy6BR;AoBv6BM;EACE,eAAA;ApBy6BR;AApzBA;EoBhHM,iBAAA;ApBu6BN;AAvzBA;EoB7GQ,mBAAA;EACA,cAAA;EACA,gBAAA;ApBu6BR;AA5zBA;EoBvGQ,kBAAA;EACA,cAAA;ApBs6BR;AAh0BA;EqB/JI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;ArBk+BJ;AAt0BA;EqBzJM,YAAA;EACA,WAAA;EACA,aAAA;ArBk+BN;AA30BA;EqBlJI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;ArBg+BJ;AAn1BA;EqBxIM,aAAA;EACA,eAAA;ArB89BN;AAv1BA;EqBjIM,aAAA;EACA,sBAAA;ArB29BN;AA31BA;EqB5HQ,WAAA;ArB09BR;AA91BA;EqBzHU,mBAAA;EACA,kBAAA;ArB09BV;AAl2BA;EqBnHU,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;ArBw9BV;AAx2BA;EqB5GU,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;ArBu9BV;AA92BA;EqBrGU,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;ArBs9BV;AAp3BA;EqB/FY,gBAAA;ArBs9BZ;AAv3BA;EqBzFQ,YAAA;ArBm9BR;AA13BA;EqBpFM,mBAAA;ArBi9BN;AA73BA;EsB1JI,aAAA;EACA,0BAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AtB0hCJ;AAp4BA;EsBnJM,aAAA;AtB0hCN;AAv4BA;EsBhJQ,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AtB0hCR;AA/4BA;EsBvIQ,cAAA;AtByhCR;AAl5BA;EsBpIU,gBAAA;AtByhCV;AAr5BA;EsBhIU,cAAA;EACA,kBAAA;AtBwhCV;AAz5BA;EsB3HU,mBAAA;EACA,kBAAA;AtBuhCV;AA75BA;EsBtHU,gBAAA;AtBshCV;AAh6BA;EsBjHQ,gBAAA;EACA,iBAAA;EACA,6BAAA;AtBohCR;AAr6BA;EsB1GM,YAAA;EACA,YAAA;EACA,cAAA;AtBkhCN;AA16BA;EuBhKE,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AvB6kCF;AuB3kCE;EACE,gBAAA;EACA,SAAA;AvB6kCJ;AAv7BA;EuBlJI,gBAAA;EACA,aAAA;AvB4kCJ;AA37BA;EuB9IM,cAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;AvB4kCN;AAj8BA;EuBvIM,mBAAA;EACA,kBAAA;AvB2kCN;AAr8BA;EuBjII,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AvBykCJ;AA38BA;EuB1HI,aAAA;EACA,uBAAA;AvBwkCJ;AA/8BA;EuBtHM,WAAA;AvBwkCN;AAl9BA;EwBhKE,aAAA;AxBqnCF;AAr9BA;EwB7JI,oBAAA;AxBqnCJ;AwBnnCI;EACE,mBAAA;AxBqnCN;AA39BA;EwBtJM,gBAAA;EACA,cAAA;EACA,mBAAA;AxBonCN;AAh+BA;EwBhJM,cAAA;AxBmnCN;AAn+BA;EwB5IM,cAAA;EACA,kBAAA;EACA,gBAAA;AxBknCN;AAx+BA;EwBvIQ,YAAA;AxBknCR;AA3+BA;EwBpIU,iBAAA;AxBknCV;AA9+BA;EwBhIU,YAAA;EACA,WAAA;AxBinCV;AAl/BA;EwB1HQ,qBAAA;AxB+mCR;AAr/BA;EwBpHI,iBAAA;EACA,kBAAA;EACA,UAAA;AxB4mCJ;AA1/BA;EwB9GI,sBAAA;EACA,mBAAA;AxB2mCJ;AwBzmCI;EACE,WAAA;EACA,iBAAA;AxB2mCN;AAlgCA;EwBpGI,iBAAA;EACA,kBAAA;AxBymCJ;AAtgCA;EwBhGM,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AxBymCN;AA5gCA;EwBzFM,UAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AxBwmCN;AwBtmCM;EACE,qBAAA;AxBwmCR;AAxhCA;EwB3EM,aAAA;AxBsmCN;AA3hCA;EwBvEM,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;AxBqmCN;AApiCA;EwB7DM,iBAAA;EACA,gBAAA;AxBomCN;AwBlmCM;EACE,cAAA;AxBomCR;AwBlmCM;EACE,cAAA;AxBomCR;AA9iCA;EwBjDM,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AxBkmCN;AAtjCA;EwBvCM,YAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;AxBgmCN;AAnkCA;EwBvBE,iBAAA;AxB6lCF;AAtkCA;EwBnBM,iBAAA;EACA,kBAAA;EACA,kBAAA;AxB4lCN;AA3kCA;EyBhKE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AzB8uCF;AArlCA;EyBtJI,qBAAA;AzB8uCJ;AAxlCA;EyBnJM,mBAAA;EACA,gBAAA;AzB8uCN;AA5lCA;EyB9IM,mBAAA;AzB6uCN;AA/lCA;EyBzII,aAAA;AzB2uCJ;AAlmCA;E0BhKE,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,YAAA;A1BqwCF;AAxmCA;E0B1JI,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,gCAAA;EACA,sBAAA;EACA,eAAA;A1BqwCJ;AAlnCA;E0BhJM,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;A1BqwCN;AAznCA;E0BxIM,qBAAA;EACA,UAAA;A1BowCN;AA7nCA;E0BpIQ,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A1BowCR;AAvoCA;E0BzHQ,qBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;A1BmwCR;AA7oCA;E0BlHQ,mBAAA;A1BkwCR;AAhpCA;;E0B7GQ,mBAAA;EACA,kBAAA;A1BiwCR;AArpCA;E0BxGQ,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A1BgwCR;AA5pCA;E0B/FM,kBAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;A1B8vCN;AAlqCA;E0BzFQ,mBAAA;A1B8vCR;AArqCA;E0BrFQ,WAAA;EACA,YAAA;EACA,aAAA;A1B6vCR;AA1qCA;E2BhKE,cAAA;A3B60CF;AA7qCA;E2B7JI,mBAAA;A3B60CJ;AAhrCA;E2BzJI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A3B40CJ;AAtrCA;E2BnJM,oBAAA;EACA,mBAAA;A3B40CN;AA1rCA;E2B9IM,YAAA;A3B20CN;A2Bx0CI;EACE,cAAA;EACA,gBAAA;A3B00CN;AAjsCA;E4B/JI,aAAA;EACA,uBAAA;A5Bm2CJ;AArsCA;E4B3JM,YAAA;EACA,UAAA;A5Bm2CN;A4Bj2CM;EACE,YAAA;A5Bm2CR;AA5sCA;E4BnJQ,kBAAA;EACA,gBAAA;A5Bk2CR;AAhtCA;E6B9JM,sBAAA;A7Bi3CN;AAntCA;E6BzJI,UAAA;EACA,iBAAA;A7B+2CJ;AAvtCA;E6BpJI,mBAAA;EACA,gBAAA;A7B82CJ;AA3tCA;E8B/JI,mBAAA;EACA,gBAAA;A9B63CJ;AA/tCA;E8B3JM,cAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;A9B63CN;AAxuCA;E+B/JI,sBAAA;A/B04CJ;A+Bx4CI;EACE,mBAAA;A/B04CN;AA9uCA;E+BvJM,eAAA;EACA,eAAA;E5BcJ,2BAAA;EACA,yBAAA;EAEA,sBAAA;EACA,iBAAA;AH23CF;AAvvCA;E+BjJQ,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;A/B24CR;AA7vCA;EgC5JE,aAAA;EACA,cAAA;EACA,oEAAA;EACA,yBAAA;EACA,gBAAA;AhC45CF;AApwCA;EGxIE,2BAAA;EACA,yBAAA;EAEA,sBAAA;EACA,iBAAA;E6BhBE,sBAAA;EACA,yBAAA;EACA,eAAA;EAEA,aAAA;EACA,kBAAA;EACA,aAAA;AhC+5CJ;AgC75CI;EAOE,eAAA;AhCy5CN;AgCh6CI;;;EAII,cAAA;AhCi6CR;AAzxCA;EgCjIM,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,OAAA;EACA,kBAAA;EAIA,aAAA;AhC65CN;AApyCA;EgCnHM,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;AhC05CN;AAlzCA;EgCpGM,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;EACA,cAAA;EACA,OAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AhCy5CN;AAl0CA;EgCnFM,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AhCw5CN;AgCp5CE;EACE,aAAA;AhCs5CJ;AgCp5CI;EACE,oCAAA;EACA,iBAAA;AhCs5CN;AgCl5CE;EACE,iBAAA;AhCo5CJ;AgCl5CI;EACE,qCAAA;EACA,aAAA;AhCo5CN;AAt1CA;EiChKE,OAAA;EACA,mBAAA;AjCy/CF;AA11CA;EiC5JI,aAAA;EACA,cAAA;EACA,qBAAA;AjCy/CJ;AA/1CA;EkChKE,6BAAA;EACA,mBAAA;AlCkgDF;AAn2CA;;EkC3JI,cAAA;EACA,gBAAA;AlCkgDJ;AAx2CA;;EkCvJM,cAAA;AlCmgDN;AA52CA;;EkCnJM,cAAA;EACA,gBAAA;EACA,mBAAA;AlCmgDN;AAl3CA;;EkC7IM,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AlCmgDN;AA53CA;;EkCnIM,YAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AlCmgDN;AAn4CA;EkC3HI,mBAAA;AlCigDJ;AAt4CA;EkCvHI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,kBAAA;AlC+/CJ;AA74CA;EkC/GM,YAAA;AlC+/CN;AAh5CA;EmChKE,wBAAA;AnCmjDF;AAn5CA;EmC9JI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;AnCojDJ;AAz5CA;EmCxJM,YAAA;AnCojDN;AA55CA;EmCnJI,yBAAA;EACA,cAAA;EACA,gBAAA;AnCkjDJ;AmChjDI;EACE,yBAAA;AnCkjDN;AAp6CA;EmCzII,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AnCgjDJ;AmC/iDI;EACE,yBAAA;AnCijDN;AmChjDM;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;AnCkjDR;AAt7CA;EmCxHM,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AnCijDN;AmC/iDM;EACE,aAAA;AnCijDR;AAl8CA;EoChKE,cAAA;ApCqmDF;AAr8CA;EoC7JI,cAAA;ApCqmDJ;AoClmDE;EACE,aAAA;ApComDJ;AoClmDI;EACE,oCAAA;EACA,iBAAA;ApComDN;AoChmDE;EACE,iBAAA;ApCkmDJ;AoChmDI;EACE,qCAAA;EACA,aAAA;ApCkmDN;AAt9CA;EkCtGE,cAAA;EACA,gBAAA;EACA,mBAAA;AlC+jDF;AA39CA;EkCjGI,cAAA;AlC+jDJ;AA99CA;EkC3FI,cAAA;AlC4jDJ;AAj+CA;EqChKE,eAAA;EACA,gBAAA;EACA,YAAA;ElC8BA,2BAAA;EACA,yBAAA;EAEA,sBAAA;EACA,iBAAA;AHumDF;AA3+CA;EqC1JI,aAAA;EACA,gBAAA;EACA,kBAAA;ArCwoDJ;AAh/CA;EqCrJM,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;ArCwoDN;AAx/CA;EqC5IM,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;ArCuoDN;AA9/CA;EqCtIQ,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,UAAA;EAEA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;ArCuoDR;AA1gDA;EqCzHQ,kBAAA;EACA,MAAA;EACA,oCAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;ArCsoDR;AAlhDA;EqChHQ,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;ArCqoDR;AA5hDA;EqCpGM,mBAAA;ArCmoDN;AA/hDA;EqCjGQ,gBAAA;EACA,cAAA;ArCmoDR;AAniDA;EqC3FM,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;ArCioDN;AqC/nDM;EACE,cAAA;ArCioDR;AqCloDM;EACE,cAAA;ArCioDR;AAjjDA;EsChKE,gBAAA;EACA,aAAA;EACA,mBAAA;AtCotDF;AAtjDA;EGxIE,2BAAA;EACA,yBAAA;EAEA,sBAAA;EACA,iBAAA;AHisDF;AA7jDA;EsCxJM,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AtCwtDN;AsCttDM;EACE,aAAA;AtCwtDR;AAzkDA;;EsCzIM,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AtCstDN;AsCptDM;;EACE,mBAAA;EACA,YAAA;AtCutDR;AA9lDA;EsCpHM,iBAAA;AtCqtDN;AAjmDA;EsC/GI,iBAAA;EACA,eAAA;EACA,cAAA;AtCmtDJ;AAtmDA;;EuC9JI,qBAAA;EACA,aAAA;EACA,mBAAA;AvCwwDJ;AA5mDA;;EuCzJM,mBAAA;EACA,iBAAA;AvCywDN;AAjnDA;;EuCpJM,cAAA;AvCywDN;AArnDA;;EuChJM,cAAA;EACA,mBAAA;EACA,iBAAA;AvCywDN;AA3nDA;;EuCzII,cAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AvCwwDJ;AAnoDA;;;;EuCjIM,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AvC0wDN;AA5oDA;;;;EuCzHM,cAAA;AvC2wDN;AAlpDA;EqCvEI,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;ArC4tDJ;AA3pDA;EqC9DM,cAAA;EACA,kBAAA;EACA,gBAAA;ArC4tDN;AAhqDA;EwChKE,qBAAA;EACA,gBAAA;EACA,sBAAA;AxCm0DF;AArqDA;EwC3JI,YAAA;EACA,WAAA;EACA,aAAA;AxCm0DJ;AA1qDA;EyChKE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AzC60DF;AAhrDA;EyCzJM,QAAA;AzC40DN;AAnrDA;EyCpJI,aAAA;EACA,iBAAA;EACA,WAAA;AzC00DJ;AAxrDA;EyC9II,kBAAA;EACA,gBAAA;AzCy0DJ;AA5rDA;;EyCzIM,cAAA;EACA,gBAAA;AzCy0DN;AAjsDA;EyCnII,kBAAA;AzCu0DJ;AApsDA;EyC/HI,cAAA;EACA,kBAAA;EACA,mBAAA;AzCs0DJ;AAzsDA;EyCzHI,gCAAA;EACA,mBAAA;EACA,aAAA;AzCq0DJ;AA9sDA;EyCnHI,mBAAA;EACA,UAAA;AzCo0DJ;AAltDA;EyC/GM,cAAA;AzCo0DN;AArtDA;EyC1GI,gBAAA;EACA,mBAAA;AzCk0DJ;AAztDA;EyCrGI,WAAA;AzCi0DJ;A0C73DA;EAEI,qBAAA;EACA,gBAAA;A1C83DJ;A0Cj4DA;EAOI,gBAAA;A1C63DJ;A0Cp4DA;EAWI,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,gBAAA;A1C43DJ;A0C34DA;EAmBI,WAAA;EACA,aAAA;EACA,yBAAA;A1C23DJ;A0Ch5DA;EAwBM,gBAAA;EACA,gBAAA;A1C23DN;A0Cp5DA;EA8BI,WAAA;EACA,aAAA;EACA,sBAAA;A1Cy3DJ;A0Cz5DA;EAmCM,iBAAA;EACA,6BAAA;A1Cy3DN;A2C55DE;EACE;IAAK,UAAA;E3C+5DP;E2C95DE;IAAM,UAAA;E3Ci6DR;E2Ch6DE;IAAO,UAAA;E3Cm6DT;AACF;A0Cx6DA;ECQI,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,0BAAA;A3Cm6DJ;A0Cj7DA;ECmBM,iBAAA;A3Ci6DN;A0Cp7DA;EECE,6BAAA;A5Cs7DF;A0Cv7DA;EEII,qBAAA;A5Cs7DJ;A0C17DA;EEQI,qBAAA;EACA,iBAAA;A5Cq7DJ;A0C97DA;EGCE,6BAAA;A7Cg8DF;A0Cj8DA;EGII,kBAAA;A7Cg8DJ;A0Cp8DA;EICE,cAAA;A9Cs8DF;A0Cv8DA;EIII,qBAAA;A9Cs8DJ;A0C18DA;EIOM,eAAA;A9Cs8DN;A8Cp8DM;EACE,+BAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;A9Cs8DR;A8Cn8DM;EACE,cAAA;EACA,iBAAA;A9Cq8DR;A0Cv9DA;EKEI,UAAA;A/Cw9DJ;A0C19DA;EKOM,eAAA;A/Cs9DN;A+Cp9DM;EACE,cAAA;A/Cs9DR;A0Ch+DA;EMCE,6BAAA;AhDk+DF;A0Cn+DA;EMII,WAAA;AhDk+DJ;A0Ct+DA;;EMOM,mBAAA;EACA,kBAAA;AhDm+DN;AgDj+DM;;EACE,gBAAA;AhDo+DR;A0C/+DA;EMgBM,6BAAA;EAEA,mBAAA;AhDi+DN;AgD/9DM;EACE,gBAAA;AhDi+DR;AgD99DM;EACE,WAAA;AhDg+DR;AAx1DA;EAwEI,cAAA;AAmxDJ;AGn9DE;E8CzCF;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,SAAA;IACA,QAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EjD+/DA;EiDxgEF;IAaM,aAAA;EjD8/DJ;EiD3gEF;IAiBM,cAAA;IACA,cAAA;IACA,kBAAA;EjD6/DJ;EkDhhEF;IACE,WAAA;ElDkhEA;EmDnhEF;IAEI,WAAA;IACA,eAAA;IACA,gBAAA;EnDohEF;EoDxhEF;IAGM,kBAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IACA,aAAA;IACA,eAAA;EpDwhEJ;EoDjiEF;IAYQ,WAAA;IACA,mBAAA;IACA,gBAAA;IACA,cAAA;IACA,cAAA;IACA,sBAAA;EpDwhEN;EoDthEM;IACE,QAAA;EpDwhER;EoDrhEM;IACE,QAAA;EpDuhER;EqD/iEF;IACE,WAAA;ErDijEA;EqDljEF;IAII,sBAAA;IACA,oBAAA;ErDijEF;EqDtjEF;IAQM,cAAA;ErDijEJ;EqDzjEF;;IAYM,iBAAA;ErDijEJ;EqD7jEF;;IAgBM,sBAAA;ErDijEJ;EqDjkEF;IAoBM,aAAA;ErDgjEJ;EqD3iEF;IAEI,kBAAA;ErD4iEF;EqD3iEE;IACE,gBAAA;ErD6iEJ;EsD1kEF;IACE,YAAA;IACA,eAAA;EtD4kEA;EsD9kEF;IAKI,WAAA;IACA,sBAAA;EtD4kEF;EsDllEF;IASM,sBAAA;EtD4kEJ;EsDrlEF;IAcI,0BAAA;EtD0kEF;EuDjlEF;IACE,WAAA;EvDmlEA;EuDplEF;ICNE,2BAAA;IACA,kBAAA;ExD6lEA;EuDxlEF;ICFI,kBAAA;ExD6lEF;EuD3lEF;ICEI,sBAAA;IACA,cAAA;ExD4lEF;EuD/lEF;;;ICQM,aAAA;ExD4lEJ;EuDpmEF;ICYM,WAAA;IACA,YAAA;ExD2lEJ;EuDxmEF;ICkBI,aAAA;ExDylEF;EuD3mEF;ICuBM,WAAA;IACA,eAAA;ExDulEJ;EuD/mEF;IC8BM,WAAA;IACA,eAAA;IACA,gBAAA;ExDolEJ;EuDpnEF;IENE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,kBAAA;EzD6nEA;EuD1nEF;;IEAI,aAAA;EzD8nEF;EuD9nEF;IEII,mBAAA;IACA,gBAAA;IACA,WAAA;EzD6nEF;EuDnoEF;IESM,cAAA;EzD6nEJ;EuDtoEF;IEaM,YAAA;IACA,WAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;EzD4nEJ;EuD7oEF;IAOI,WAAA;IACA,cAAA;EvDyoEF;EuDjpEF;IGNE,WAAA;E1D0pEA;EuDppEF;IGJI,WAAA;E1D2pEF;EuDvpEF;IGAQ,aAAA;E1D0pEN;EuD1pEF;IGKM,WAAA;E1DwpEJ;EuD7pEF;;;;IGYQ,eAAA;E1DupEN;EuDnqEF;;;;IGeU,eAAA;IACA,mBAAA;E1D0pER;EuD1qEF;;;;IGoBU,WAAA;E1D4pER;EuDhrEF;IG4BM,eAAA;E1DupEJ;EuDnrEF;IINE,mBAAA;E3D4rEA;EuDtrEF;IIHI,sBAAA;IACA,mBAAA;E3D4rEF;EuD1rEF;;IIGI,YAAA;E3D2rEF;EuD9rEF;IIOI,cAAA;E3D0rEF;EuDjsEF;IKLI,cAAA;E5DysEF;E4DtsEI;IACE,eAAA;E5DwsEN;EuDvsEF;IMLI,iBAAA;IACA,WAAA;E7D+sEF;E6D7sEE;IACE,mBAAA;E7D+sEJ;EuD9sEF;IONE,2BAAA;E9DutEA;EuDjtEF;IQNE,UAAA;IACA,WAAA;E/D0tEA;EuDrtEF;ISNE,gBAAA;IACA,SAAA;IACA,aAAA;EhE8tEA;EgE5tEA;IAEE,gBAAA;IAGA,mBAAA;EhE2tEF;EuD9tEF;ISOI,aAAA;EhE0tEF;EuDjuEF;IULI,gBAAA;IACA,mBAAA;EjEyuEF;EuDruEF;IUCM,UAAA;IACA,yBAAA;EjEuuEJ;EuDzuEF;IUMM,cAAA;EjEsuEJ;EuD5uEF;IUUM,kBAAA;IACA,OAAA;IACA,SAAA;IACA,gBAAA;EjEquEJ;EuDlvEF;IWLI,eAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,mBAAA;ElE0vEF;EuDzvEF;IYNE,YAAA;EnEkwEA;EuD5vEF;IYHI,YAAA;IACA,qBAAA;EnEkwEF;EuDhwEF;;IaLI,sBAAA;EpEywEF;EuDpwEF;;IaFM,cAAA;EpE0wEJ;EuDxwEF;;IaEM,cAAA;EpE0wEJ;EuD5wEF;;IaMM,cAAA;EpE0wEJ;EuDhxEF;;IaWI,wBAAA;IACA,UAAA;EpEywEF;EuDrxEF;;;;IaeM,aAAA;EpE4wEJ;EuD3xEF;IYII,SAAA;IACA,eAAA;IACA,WAAA;EnE0xEF;EuDhyEF;IcNE,mBAAA;ErEyyEA;EuDnyEF;IcHI,eAAA;ErEyyEF;EuDtyEF;IcCI,UAAA;IACA,kBAAA;IACA,gBAAA;ErEwyEF;EuD3yEF;IeLI,gBAAA;EtEmzEF;EuD9yEF;;IeAM,sBAAA;EtEkzEJ;EuDlzEF;IeIM,aAAA;EtEizEJ;EuDrzEF;IgBLI,WAAA;EvE6zEF;EuDxzEF;IgBDI,iBAAA;IACA,kBAAA;EvE4zEF;EuD5zEF;IiBNE,aAAA;IACA,yBAAA;ExEq0EA;EuDh0EF;IkBNE,YAAA;EzEy0EA;E0E10EF;IAEI,8BAAA;IACA,oBAAA;E1E20EF;E0E90EF;IAMM,mBAAA;IACA,eAAA;E1E20EJ;E0El1EF;IAYI,UAAA;E1Ey0EF;E0Er1EF;IAgBQ,WAAA;E1Ew0EN;E0Ex1EF;IAoBY,cAAA;IACA,gBAAA;E1Eu0EV;AACF;AAzmEA;EA2mEE,qFAAqF;EAzmErF,iCAAA;EACA,WAAA;AA2mEF;AAxmEA;E2EzPE,gBAAA;EACA,eAAA;A3Eo2EF;AA5mEA;E2ErPI,yBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;A3Eo2EJ;A2Ej2EE;EACE,UAAA;EACA,sCAAA;A3Em2EJ;A2Ej2EE;EACE,WAAA;EACA,uCAAA;A3Em2EJ;AA/nEA;E2EhOI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;A3Ek2EJ;A2Eh2EI;EACE,YAAA;A3Ek2EN;AA9oEA;;E2E/MM,cAAA;A3Ei2EN;AAlpEA;E2E3MM,cAAA;EACA,kBAAA;A3Eg2EN;A2E51EE;EACE,UAAA;A3E81EJ;A2E51EE;EACE,WAAA;A3E81EJ","sourcesContent":["@font: \"Graphik\", sans-serif;\n\n@light: 300;\n@regular: 400;\n@semi-bold: 600;\n@bold: 700;\n\n@font-face {\n  font-family: \"Graphik\";\n  src: url(\"~fonts/Graphik-Regular.otf\") format(\"opentype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Graphik\";\n  src: url(\"~fonts/Graphik-Semibold.otf\") format(\"opentype\");\n  font-weight: @semi-bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Graphik\";\n  src: url(\"~fonts/Graphik-Bold.otf\") format(\"opentype\");\n  font-weight: @bold;\n  font-style: normal;\n}\n","@import \"colors\";\n@import \"fonts\";\n@import \"mixins\";\n\n// Why rem?\n// rem values are relative to the root html element,\n// not the parent element as in the case of ems -\n// setting font-sizes in ems, relative to the\n// parent, can cause unexpected compounding of font-sizes.\n// https://developer.mozilla.org/en-US/docs/Web/CSS/font-size\n@xxs-type: 0.625rem;\n@xs-type: 0.75rem;\n@s-type: 0.875rem;\n@m-type: 1rem; // 14px\n@l-type: 1.125rem;\n@xl-type: 1.25rem;\n@xxl-type: 1.45rem;\n@xxxl-type: 1.875rem;\n\n@radius: 5px;\n@input-radius: 2px;\n@border: 1px solid @grey-50;\n\n@import \"icon\";\n@import \"button\";\n@import \"checkbox\";\n@import \"forms\";\n@import \"toggle\";\n@import \"picker\";\n@import \"loader\";\n@import \"overlay\";\n@import \"modal\";\n@import \"alert_modal\";\n@import \"confirm_modal\";\n@import \"online_ordering/preview_banner\";\n\nhtml {\n  height: 100%;\n  // This is our base font size. All other sizes are set in\n  // rems in relation to this base. The default font-size for\n  // browsers is 16px, so here we our setting our base to 14px. It's\n  // important for accessibility not to set this to a hard px value\n  // because then users cannot scale the text.\n  font-size: 87.5%;\n}\n\nbody {\n  margin: 0;\n  height: 100%;\n}\n\n#root {\n  height: 100%;\n}\n\nh1,\nh3 {\n  color: @grey-80;\n  font-weight: @light;\n}\n\nh2 {\n  color: @grey-90;\n  font-size: @xxl-type;\n  font-weight: @regular;\n  margin: 0.1em 0;\n}\n\nh3 {\n  font-size: @l-type;\n}\n\nh4 {\n  color: @grey-90;\n  font-size: @xl-type;\n  font-weight: @regular;\n  margin: 20px 0 0;\n}\n\nh5 {\n  margin-top: 0;\n  color: @grey-90;\n  font-size: @m-type;\n  font-weight: @semi-bold;\n  margin-bottom: 10px;\n}\n\na {\n  color: @blue;\n  cursor: pointer;\n  text-decoration: none;\n}\n\ntable {\n  font-size: @s-type;\n  border-collapse: collapse;\n\n  th {\n    font-weight: @light;\n    padding: 0px 12px 10px;\n  }\n\n  td {\n    padding: 10px 12px 28px;\n  }\n}\n\nbutton {\n  font-family: @font;\n}\n\ninput {\n  font-family: @font;\n}\n\nul {\n  list-style: none;\n  padding-left: 0;\n}\n\n.bold {\n  font-weight: @bold;\n}\n\n.semi-bold {\n  font-weight: @semi-bold;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n// Hide sections that do not yet have backend support for MVP\n// Override no matter what if we have this class\n.hidden {\n  display: none !important;\n}\n\n.hidden-iframe {\n  border: none;\n  display: none;\n}\n\n.landing {\n  text-align: center;\n\n  .ghost {\n    width: 100px;\n    height: 100px;\n    margin: 40px 0 0 -40px;\n  }\n}\n\n// When a modal is shown prevent scrolling of background\n.freeze-body {\n  overflow: hidden;\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n}\n\n.app {\n  width: 100%;\n  max-width: 1080px;\n  margin: 0 auto;\n  min-height: 100%;\n  position: relative;\n  line-height: 1.5;\n\n  @import \"header\";\n  @import \"footer\";\n  @import \"location_info\";\n\n  .content {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    width: 100%;\n    box-sizing: border-box;\n\n    > .loader {\n      flex-basis: 100%;\n    }\n\n    &.loyalty-only {\n      padding: 0;\n    }\n\n    .card {\n      background-color: @white;\n      border-radius: @radius;\n      .box-shadow(0 2px 2px 0 rgba(0, 0, 0, 0.1));\n\n      &.main-view {\n        margin-bottom: 60px;\n      }\n    }\n    .message-banner {\n      padding: 0 20px;\n      margin: 20px 0;\n      background-color: @error-background;\n      width: 100%;\n      display: flex;\n      align-items: center;\n\n      .icon {\n        color: @error-red;\n        height: 30px;\n        width: auto;\n      }\n\n      .message-content {\n        padding-left: 20px;\n      }\n\n      .message-header {\n        font-weight: @semi-bold;\n      }\n    }\n\n    @import \"loyalty\";\n    @import \"online_ordering/cart\";\n    @import \"online_ordering/menu\";\n    @import \"online_ordering/main_view\";\n    @import \"online_ordering/checkout\";\n    @import \"online_ordering/item_modal\";\n    @import \"online_ordering/tooltip\";\n  }\n\n  @import \"online_ordering/checkout/order_confirm_modal\";\n  @import \"account\";\n\n  .icon-wrapper {\n    line-height: 0;\n  }\n}\n\n.mobile( {\n    @import \"mobile\";\n  }\n\n);\n\n// Hide \"powered by Google\" from address editor\n.pac-container:after {\n  /* Disclaimer: not needed to show 'powered by Google' if also a Google Map is shown */\n  background-image: none !important;\n  height: 0px;\n}\n\n#portal-root {\n  @import \"portal-tooltip\";\n}\n",".icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  vertical-align: baseline;\n\n  &.star {\n    fill: none;\n  }\n\n  &.large {\n    width: 50px;\n    height: 60px;\n  }\n}\n\n.icon-wrapper.circled {\n  background-color: white;\n  border-radius: 50%;\n  display: inline-block;\n  padding: 8px;\n  text-align: center;\n  height: 20px;\n  width: 20px;\n}\n","button {\n  border-radius: @radius;\n  border: 0;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 150%;\n  padding: 0.75em 12px;\n  text-align: center;\n\n  &.caps {\n    font-weight: @semi-bold;\n    text-transform: uppercase;\n  }\n\n  &.large {\n    font-size: @l-type;\n    font-weight: @semi-bold;\n  }\n\n  &.medium {\n    font-size: @m-type;\n    font-weight: @semi-bold;\n  }\n\n  &.small {\n    font-size: @s-type;\n  }\n\n  .transition(background-color 0.1s ease-in);\n\n  &:hover {\n    color: @white;\n    border: 0;\n  }\n\n  &.sharp-corners {\n    border-radius: 0;\n  }\n\n  .not-selectable;\n\n  &.secondary {\n    background-color: @white;\n    border: 1px solid @blue-100;\n    color: @blue-100;\n\n    &:hover {\n      background-color: @white;\n    }\n  }\n\n  &.text {\n    color: @blue;\n    font-size: 1em;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  &.disabled {\n    color: @white;\n\n    &:hover {\n      background-color: @grey-90;\n    }\n  }\n}\n",".transform(@args) {\n  -webkit-transform: @args;\n  -moz-transform: @args;\n  transform: @args;\n}\n\n.box-shadow(@args) {\n  -webkit-box-shadow: @args;\n  -moz-box-shadow: @args;\n  box-shadow: @args;\n}\n\n.transition(@args) {\n  -webkit-transition: @args;\n  -moz-transition: @args;\n  transition: @args;\n}\n\n.animation(@args) {\n  -webkit-animation: @args;\n  -moz-animation: @args;\n  animation: @args;\n}\n\n.not-selectable() {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n\n.selectable() {\n  -webkit-touch-callout: auto;\n  -webkit-user-select: auto;\n  -khtml-user-select: auto;\n  -moz-user-select: auto;\n  user-select: auto;\n}\n\n.mobile(@rules) {\n  @media (max-width: 1024px) {\n    @rules();\n  }\n}\n",".checkbox-option {\n  display: inline-block;\n  position: relative;\n\n  label {\n    padding: 0 5px;\n    cursor: pointer;\n    &.disabled {\n      opacity: 0.75;\n      cursor: default;\n    }\n  }\n\n  .checkmark {\n    left: 4px;\n    position: absolute;\n    top: 8px;\n    display: none;\n    height: 12px;\n    width: 12px;\n  }\n}\n\n.text-alerts {\n  display: inline-flex;\n  align-items: center;\n  line-height: 22px;\n}\n\ninput[type=\"checkbox\"] {\n  appearance: none;\n  border: 1px solid @blue;\n  height: 14px;\n  width: 14px;\n  position: relative;\n  top: 5px;\n  cursor: pointer;\n\n  &:checked {\n    background-color: @blue;\n    position: relative;\n    top: 5px;\n\n    + label .checkmark {\n      display: inline-block;\n    }\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.75;\n    border-color: @grey-90;\n  }\n}\n",".form {\n  .row {\n    margin: 13px 0;\n    display: flex;\n    align-items: center;\n\n    &:first-of-type {\n      margin-top: 0;\n    }\n\n    .multi-field {\n      display: flex;\n      flex-grow: 1;\n      gap: 20px;\n    }\n\n    .label, .label-text, label {\n      width: 120px;\n      font-weight: @semi-bold;\n      font-size: @s-type;\n      color: @grey-90;\n      flex-shrink: 0;\n    }\n\n    label.cvv, label.zip {\n      margin-right: 4px;\n      margin-left: 20px;\n    }\n\n    label.shrink,\n    .label-text.shrink {\n      flex-shrink: 1;\n    }\n\n    @media (min-width: 1025px) {\n      label.cvv, label.zip {\n        flex-shrink: 0;\n        padding-right: 2px;\n        text-align: right;\n        width: auto;\n      }\n    }\n\n    .expiry-divider {\n      font-size: @xxl-type;\n    }\n\n    .text-input {\n      flex-grow: 1;\n      flex-shrink: 1;\n    }\n  }\n}\n\n.text-input {\n  input {\n    color: @grey-80;\n    width: 100%;\n    height: 100%;\n    padding: 8px;\n    font-size: @m-type;\n    font-weight: @light;\n    border-radius: @input-radius;\n    border: @border;\n    box-sizing: border-box;\n\n    &.exp {\n      max-height: 37px;\n    }\n  }\n\n  &.error {\n    input {\n      border: 1px solid @red;\n    }\n\n    .error-text {\n      margin: 2px;\n      color: @red;\n      font-size: @xs-type;\n      font-weight: @regular;\n      display: block;\n    }\n  }\n}\n\n.adyen-input {\n  flex-grow: 1;\n\n  span[data-cse] {\n    line-height: 0;\n    display: block;\n    background: white;\n  }\n\n  iframe {\n    border-radius: @input-radius;\n    border: @border;\n    box-sizing: border-box;\n    height: 33px;\n    padding: 0;\n    width: 100%;\n  }\n\n  &.error iframe {\n    border-color: @red;\n  }\n\n  &.focus iframe {\n    border: 2px solid #101010;\n  }\n}\n",".toggle {\n  display: flex;\n\n  .toggle-option {\n    flex-grow: 1;\n    text-align: center;\n    padding: 10px;\n    font-size: @s-type;\n    color: @grey-80;\n    font-weight: @regular;\n    border: 1px solid @grey-50;\n\n    &.selected {\n      color: @blue;\n      border-color: @blue;\n    }\n  }\n}\n",".picker {\n  display: inline-block;\n  width: 100%;\n  background-color: @white;\n\n  &.expanded {\n    .options {\n      z-index: 500;\n      border: @border;\n\n      .option {\n        &.selected {\n          width: 100%;\n          .icon {\n            position: relative;\n            top: -1px;\n            height: 13px;\n            width: 13px;\n\n            #toggle {\n              stroke: @blue;\n            }\n          }\n        }\n\n        &:last-of-type {\n          border-top: @border;\n          font-weight: @regular;\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  .current {\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    border: @border;\n    border-radius: @radius;\n    margin: 0;\n\n    .option {\n      .icon {\n        display: none;\n      }\n    }\n\n    .icon-wrapper {\n      position: relative;\n      top: 13px;\n      right: 21px;\n    }\n\n    .icon {\n      width: 12px;\n      height: 12px;\n      fill: @blue;\n      // vertical-align: top;\n    }\n  }\n\n  &.error {\n    .current {\n      border-color: @red;\n    }\n  }\n\n  .error-text {\n    margin: 2px;\n    color: @red;\n    font-size: @xs-type;\n    font-weight: @regular;\n  }\n\n  .options {\n    border-radius: @radius;\n    margin: 2px 0 0;\n    .box-shadow(0 2px 2px 0 rgba(0, 0, 0, 0.1));\n  }\n\n  .option {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 240px;\n    padding: 10px 20px;\n    cursor: pointer;\n    box-sizing: border-box;\n  }\n}\n","@-webkit-keyframes spin {\n  0% { -webkit-transform:rotate(0deg); }\n  100% { -webkit-transform:rotate(360deg); }\n}\n@-moz-keyframes spin {\n  0%    { -moz-transform:rotate(0deg); }\n  100%  { -moz-transform:rotate(360deg); }\n}\n@keyframes spin {\n  0%    { transform:rotate(0deg); }\n  100%  { transform:rotate(360deg); }\n}\n\n.loader {\n  position: relative;\n\n  .indicator {\n    position: absolute;\n    top: -10px;\n    right: -10px;\n    bottom: -10px;\n    left: -10px;\n    z-index: 1000;\n\n    .logo {\n      position: absolute;\n      top: 150px;\n      left: 50%;\n      margin-left: -20px;\n      width: 44px;\n      height: 44px;\n      border: 2px solid transparent;\n      background: url('~images/upserve_loader_icon.png');\n      background-size: cover;\n    }\n\n    &:after {\n      content: ' ';\n      position: absolute;\n      top: 150px;\n      left: 50%;\n      margin-left: -20px;\n\n      width: 40px;\n      height: 40px;\n      border-radius: 40px;\n      border: 4px solid rgba(0, 0, 0, 0.2);\n      border-top-color: rgba(0, 0, 0, 0.3);\n      .animation(spin 1s infinite linear);\n    }\n  }\n\n  &.large {\n    .indicator {\n      .logo {\n        zoom: 2;\n      }\n      &:after {\n        zoom: 2;\n      }\n    }\n  }\n}\n",".overlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 3000;\n  background: rgba(51, 51, 51, 0.8);\n  .transition(background 0.4s ease-out);\n}\n",".modal {\n  position: fixed;\n  z-index: 3500;\n  top: 50%;\n  left: 0px;\n  right: 0px;\n  margin: 0 auto;\n  width: 500px;\n  max-width: 100%;\n  border-radius: @radius;\n  background-color: @white;\n  text-align: left;\n  .box-shadow(1px 1px 2px rgba(0, 0, 0, 0.25));\n  .transform(translateY(-50%));\n\n  .close {\n    float: right;\n\n    .icon-wrapper {\n      position: absolute;\n      height: 14px;\n      right: 20px;\n      top: 20px;\n    }\n\n    .icon {\n      fill: @grey-80;\n      width: 14px;\n      height: 14px;\n    }\n  }\n\n  header {\n    padding: 18px 22px;\n    border-bottom: 1px solid @grey-50;\n\n    .mobile-title {\n      color: @grey-90;\n      font-size: @xl-type;\n      display: none;\n    }\n  }\n\n  .contents {\n    margin: 20px;\n\n    .message {\n      margin-bottom: 20px;\n    }\n  }\n\n  .login-footer {\n    padding: 8px;\n    text-align: center;\n    border-top: 1px solid @grey-50;\n\n    a {\n      color: @black;\n\n      .logo-icon {\n        height: 39px;\n        width: 162px;\n        position: relative;\n        top: 2px;\n      }\n    }\n  }\n}\n",".alert-modal {\n  .contents {\n    text-align: center;\n    width: 420px;\n    margin: 20px auto;\n\n    .button {\n      width: 100%;\n      box-sizing: border-box;\n    }\n  }\n}\n",".confirm-modal {\n  .confirm-actions {\n    text-align: right;\n\n    .button {\n      margin-left: 5px;\n      width: 120px;\n    }\n  }\n}\n",".preview-banner {\n  background-color: @grey-95;\n  color: @white;\n  height: 100px;\n\n  button {\n    border: 1px solid white;\n  }\n\n  a {\n    text-decoration: underline;\n  }\n\n  .inner {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    align-content: center;\n    width: 1024px;\n    margin: 0 auto;\n    height: 100%;\n\n    .left {\n      align-self: center;\n      flex-basis: 80%;\n      line-height: 1.2rem;\n      padding-left: 20px;\n\n      .text {\n        margin: 10px 0;\n\n        .emphasis {\n          font-weight: 600;\n        }\n      }\n\n      a {\n        color: @white;\n      }\n    }\n\n    .right {\n      padding-left: 20px;\n      align-self: center;\n\n      a {\n        border: 1px solid @white;\n        padding: 0px 30px;\n      }\n    }\n  }\n\n  .modal-content {\n    padding: 20px;\n    color: @grey-80;\n\n    .body {\n      margin-bottom: 20px;\n    }\n\n    button {\n      margin: 10px 0;\n      width: 60%;\n    }\n\n    .animation {\n      width: 100px;\n      height: 100px;\n    }\n\n    .center {\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n    }\n  }\n}\n",".header {\n  display: flex;\n  background-size: auto 100%;\n  width: 100%;\n  height: 128px;\n  padding: 30px 40px;\n  box-sizing: border-box;\n  color: @white;\n  text-shadow: 0 0 10px rgba(45, 44, 158, 0.25);\n\n  .location-details {\n    flex-grow: 1;\n\n    .location-name {\n      font-size: @xxxl-type;\n      font-weight: @semi-bold;\n      letter-spacing: 0.025em;\n      line-height: 1.2em;\n\n      // clearing button css\n      background-color: transparent;\n      border-radius: none;\n      border: 0;\n      color: auto;\n      display: auto;\n      padding: 0;\n      text-align: inherit;\n    }\n\n    .hours {\n      font-size: @m-type;\n      font-weight: bold;\n    }\n\n    .website,\n    .store-info {\n      font-weight: @regular;\n      font-size: @s-type;\n      letter-spacing: 0.035em;\n\n      a {\n        color: @white;\n      }\n\n      .address-spacer {\n        padding: 0 3px;\n      }\n    }\n  }\n\n  .login {\n    display: flex;\n    align-items: baseline;\n    cursor: pointer;\n    font-size: @s-type;\n    font-weight: @regular;\n    text-shadow: 0 0 10px rgba(45, 44, 158, 0.3);\n\n    .separator {\n      padding: 6px;\n    }\n  }\n\n  .login {\n    .icon-wrapper {\n      margin-right: 6px;\n    }\n\n    .icon-wrapper,\n    .icon.user {\n      position: relative;\n      top: 2px;\n      width: 17px;\n      height: 17px;\n    }\n  }\n\n  @import \"auth_modal\";\n}\n",".auth-modal {\n  text-shadow: none;\n\n  .auth-modal-button {\n    display: inline-block;\n    margin-left: 25px;\n    position: relative;\n    text-align: center;\n    cursor: pointer;\n\n    .icon-wrapper {\n      margin-bottom: 5px;\n    }\n\n    .icon-overlay {\n      font-size: 11px;\n      left: 50%;\n      position: absolute;\n      top: 13px;\n      transform: translateX(-50%);\n    }\n  }\n\n  .contents {\n    color: @grey-80;\n    width: 400px;\n    margin: 20px auto;\n    text-align: left;\n    font-size: @m-type;\n\n    .modal-copy {\n      margin-bottom: 20px;\n    }\n\n    &.with-loader {\n      height: 284px;\n\n      .loader {\n        top: -50px;\n      }\n    }\n\n    input {\n      height: 38px;\n      margin: 5px 0;\n    }\n\n    .reset-password-button,\n    .login-button,\n    .set-password-button,\n    .button {\n      display: block;\n      width: 100%;\n      height: 50px;\n      margin: 10px 0;\n      box-sizing: border-box;\n      font-size: @m-type;\n    }\n\n    .forgot-password,\n    .create-account,\n    .show-login {\n      display: block;\n      font-weight: @regular;\n      margin: 15px 0;\n    }\n  }\n\n  .outlined-button {\n    padding: 6px 8px;\n    border: 2px solid @white;\n    background-color: @grey-90;\n    border-radius: @radius;\n    color: @white;\n    display: flex;\n    align-items: center;\n    line-height: 1;\n    gap: 10px;\n    font-size: 16px;\n\n    .icon {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .account-info {\n    color: @white;\n    font-size: 16px;\n    cursor: auto;\n\n    .icon {\n      width: 16px;\n      height: 16px;\n    }\n\n    a {\n      color: @white;\n      text-decoration: underline;\n    }\n  }\n\n  @import \"authentication/sent_modal\";\n}\n",".sent-modal {\n  .message {\n    margin: 30px auto;\n\n    div + div {\n      margin-top: 15px;\n    }\n  }\n}\n",".footer {\n  background-color: @white;\n  bottom: 0;\n  box-sizing: border-box;\n  color: @black;\n  display: flex;\n  font-size: @s-type;\n  height: 44px;\n  padding: 0 14px;\n  vertical-align: middle;\n  .box-shadow(0 0 4px 0 rgba(0, 0, 0, 0.1));\n  align-items: center;\n\n  .outside-reference {\n    flex-grow: 1;\n    text-align: left;\n    padding: 14px 0;\n    .separator {\n      padding: 4px;\n      color: @blue;\n    }\n  }\n\n  .upserve {\n    display: block;\n    height: fit-content;\n\n    a {\n      display: block;\n      line-height: 0;\n    }\n\n    .logo-icon {\n      width: 108px;\n    }\n  }\n}\n",".location-info {\n  padding: 20px;\n  margin-bottom: 20px;\n\n  .promo-description {\n    font-size: @l-type;\n    color: @grey-80;\n    border-bottom: @border;\n    line-height: 1.8em;\n    padding-bottom: 20px;\n  }\n\n  .lower {\n    display: flex;\n    flex-direction: row;\n    margin: 20px 0;\n    padding-bottom: 20px;\n\n    .location {\n      color: @grey-90;\n      font-size: @l-type;\n      font-weight: @regular;\n      line-height: 1.8em;\n      margin-right: 50px;\n      margin-bottom: 20px;\n\n      .website {\n        margin-top: 20px;\n\n        a {\n          color: @blue;\n        }\n      }\n    }\n  }\n}\n",".reward-progress-bar {\n  padding: 10px 20px;\n  border: 1px solid @green;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n\n  span {\n    margin: 0 5px;\n    color: @grey-80;\n  }\n\n  .bar {\n    width: 100%;\n    height: 18px;\n    flex-grow: 1;\n    border-radius: @radius;\n    background-color: @grey-40;\n    overflow: hidden;\n\n    .completed {\n      display: inline-block;\n      height: 18px;\n      width: 0%;\n      margin: 0;\n      background-color: @green;\n    }\n  }\n}\n",".mini-loyalty {\n  margin: 5px;\n\n  .reward {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    width: 650px;\n    padding: 5px;\n    box-sizing: border-box;\n\n    &.mini-point-reward {\n      .reward-content {\n        display: flex;\n        flex-grow: 1;\n        justify-content: space-between;\n\n        .description {\n          font-size: @s-type;\n          color: @grey-90;\n          margin: 0 10px;\n        }\n\n        .reward-progress-bar {\n          border: none;\n          align-self: flex-end;\n          flex-basis: 500px;\n          flex-grow: 0;\n        }\n      }\n    }\n\n    .icon-wrapper {\n      margin: 10px;\n    }\n\n    .icon {\n      height: 30px;\n      width: 30px;\n\n      &.price-tag {\n        fill: @green;\n      }\n      &.star {\n        stroke: @green;\n      }\n    }\n\n    .reward-content {\n      margin-left: 10px;\n\n      .title {\n        font-size: @s-type;\n        color: @grey-90;\n        font-weight: @semi-bold;\n      }\n\n      .description {\n        font-size: @xs-type;\n        color: @grey-80;\n      }\n    }\n  }\n}\n",".loyalty-sign-up {\n  .text-input {\n    flex-grow: 1;\n    height: 45px;\n    font-size: @l-type;\n    margin-right: 20px;\n\n    input {\n      height: 45px;\n      width: 100%;\n      padding: 12px;\n    }\n  }\n\n  .button {\n    flex-grow: 0;\n    font-size: @m-type;\n    font-weight: @regular;\n    width: 141px;\n    height: 45px;\n    vertical-align: middle;\n  }\n\n  .email-entry {\n    .email-form {\n      display: flex;\n      flex-wrap: wrap;\n    }\n  }\n\n  .card-entry {\n    .card-form {\n      display: flex;\n      flex-direction: column;\n\n      // Match account form layout for shared LoyaltyAccountCreditCardForm\n      .form.expanded-form.edit-credit-card {\n        width: 100%;\n\n        .row {\n          align-items: center;\n          margin-bottom: 4px;\n        }\n\n        // Allow .text-input wrapper to grow when error is shown (default height: 45px clips it)\n        .text-input {\n          height: auto;\n          min-height: 45px;\n          flex-direction: column;\n          display: flex;\n        }\n\n        .text-input .error-text {\n          display: block;\n          margin-top: 2px;\n          margin-bottom: 4px;\n          flex-shrink: 0;\n        }\n\n        .buttons {\n          clear: both;\n          display: flex;\n          justify-content: flex-end;\n          padding: 16px 20px;\n\n          .button {\n            min-width: 150px;\n          }\n        }\n      }\n\n      .button {\n        width: 254px;\n      }\n    }\n\n    .explanation {\n      font-size: @s-type;\n    }\n  }\n}\n","@import 'loyalty/reward_progress_bar';\n@import 'loyalty/mini_loyalty';\n\n.loyalty {\n  @import 'loyalty/sign_up';\n\n  .rewards {\n    padding: 22px;\n    border-radius: 0 0 @radius @radius;\n    box-sizing: border-box;\n    background-color: @white;\n    margin-bottom: 20px;\n\n    .reward {\n      display: flex;\n\n      .reward-photo {\n        flex-shrink: 0;\n        width: 344px;\n        height: 228px;\n        margin-right: 22px;\n        background-size: cover;\n        background-repeat: none;\n      }\n\n      .reward-content {\n        color: @grey-80;\n\n        > * + * {\n          margin-top: 12px;\n        }\n\n        .title {\n          color: @grey-90;\n          font-size: @xxl-type;\n        }\n\n        .description {\n          font-size: @l-type;\n          line-height: 1.9em;\n        }\n\n        .highlight {\n          font-weight: @bold;\n        }\n      }\n\n      + .reward {\n        margin-top: 22px;\n        padding-top: 22px;\n        border-top: 1px solid @grey-50;\n      }\n    }\n\n    .reward-progress-bar {\n      width: 418px;\n      height: 44px;\n      margin: 20px 0;\n    }\n  }\n}\n",".cart {\n  flex-basis: 334px;\n  height: 100%;\n  min-height: 500px;\n  overflow: hidden;\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n\n  &.fixed-cart {\n    position: sticky;\n    top: 20px;\n  }\n\n  .ordering-not-available {\n    font-weight: @semi-bold;\n    margin: 0 10%;\n\n    .icon {\n      display: block;\n      height: 100px;\n      margin: 38px auto;\n      width: auto;\n    }\n\n    .message {\n      margin-bottom: 20px;\n      text-align: center;\n    }\n  }\n\n  .accepting-orders {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    flex-grow: 1;\n  }\n\n  .preorder-wrapper {\n    display: flex;\n    justify-content: center;\n\n    .preorder {\n      width: 100%;\n    }\n  }\n\n  @import \"online_ordering/cart/edit_ordering_options\";\n  @import \"online_ordering/cart/ordering_options\";\n  @import \"online_ordering/cart/items\";\n  @import \"online_ordering/cart/checkout_summary\";\n  @import \"online_ordering/cart/accepting_orders\";\n  @import \"online_ordering/cart/cart_change_modal\";\n  @import \"online_ordering/cart/items_removed_modal\";\n}\n",".edit-ordering-options {\n  padding: 15px;\n\n  .order-option {\n    padding-bottom: 25px;\n\n    &:last-of-type {\n      border-bottom: none;\n    }\n\n    .title {\n      font-weight: @semi-bold;\n      color: @grey-90;\n      margin-bottom: 10px;\n    }\n\n    .toggle {\n      margin: 10px 0;\n    }\n\n    .details {\n      color: @grey-80;\n      font-size: @xs-type;\n      font-weight: @regular;\n\n      .costs {\n        float: right;\n\n        > * {\n          text-align: right\n        }\n\n        .value {\n          float: right;\n          width: 45px\n        }\n      }\n\n      .estimate {\n        display: inline-block;\n      }\n    }\n  }\n\n  .cart-prompt {\n    margin: 80px auto;\n    text-align: center;\n    width: 60%;\n  }\n\n  .button {\n    box-sizing: border-box;\n    font-size: @s-type;\n\n    &.update {\n      width: 100%;\n      margin-right: 2px;\n    }\n  }\n\n  .delivery-address-container {\n    padding-top: 20px;\n    position: relative;\n\n    label {\n      display: block;\n      margin-bottom: 5px;\n      font-size: @s-type;\n      font-weight: @semi-bold;\n    }\n\n    input {\n      width: 98%;\n      height: 24px;\n      padding: 5px 0px 5px 5px;\n      margin-top: 5px;\n      color: @grey-90;\n      border-radius: @input-radius;\n      border: @border;\n\n      &.invalid {\n        border-color: @red;\n      }\n    }\n\n    .geolocation-container {\n      display: none;\n    }\n\n    select {\n      color: @grey-90;\n      border-radius: @input-radius;\n      border: @border;\n      width: 100%;\n      height: 30px;\n      padding: 5px 0px 5px 5px;\n      background: white;\n    }\n\n    .status-message {\n      padding-top: 10px;\n      white-space: pre;\n\n      &.valid {\n        color: @green;\n      }\n      &.invalid {\n        color: @red;\n      }\n    }\n\n    .address-nag {\n      position: relative;\n      background: @green;\n      padding: 10px;\n      margin-top: 10px;\n      border-radius: @radius;\n      color: @white;\n    }\n\n    .address-nag:after {\n      // Thanks http://www.cssarrowplease.com/ !\n      bottom: 100%;\n      left: 50%;\n      border: solid transparent;\n      content: \" \";\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border-bottom-color: @green;\n      border-width: 10px;\n      margin-left: -10px;\n    }\n  }\n}\n\n.order-time-container {\n  padding-top: 20px;\n\n  .picker.expanded {\n    .options {\n      max-height: 225px;\n      overflow-y: scroll;\n      overflow-x: hidden\n    }\n  }\n}\n",".ordering-options {\n  width: 100%;\n  padding: 15px 20px;\n  box-sizing: border-box;\n  background-color: @blue;\n  color: @white;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .text {\n    display: inline-block;\n\n    .method {\n      font-size: @s-type;\n      font-weight: @regular;\n    }\n\n    .details {\n      font-size: @s-type;\n    }\n  }\n\n  .icon {\n    fill: @white;\n  }\n}\n",".items {\n  min-height: 285px;\n  max-height: calc(100vh - 450px);\n  overflow-y: auto;\n  flex-grow: 1;\n\n  .cart-item {\n    cursor: pointer;\n    padding: 15px 10px;\n    position: relative;\n    width: auto;\n    margin: 0 10px;\n    border-bottom: @border;\n    box-sizing: border-box;\n    font-size: @m-type;\n\n    > .quantity {\n      display: inline-block;\n      font-weight: @regular;\n      vertical-align: top;\n      padding-right: 10px;\n      color: @grey-100;\n    }\n\n    .details {\n      display: inline-block;\n      width: 90%;\n\n      .name {\n        display: inline-block;\n        color: @blue;\n        font-weight: @regular;\n        padding-bottom: 5px;\n        max-width: 175px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .price {\n        display: inline-block;\n        float: right;\n        color: @grey-100;\n        font-weight: @regular;\n      }\n\n      .add-ons {\n        margin-bottom: 10px;\n      }\n\n      .modifier,\n      .side {\n        font-size: @s-type;\n        padding-left: 10px;\n      }\n\n      .instructions {\n        font-size: @s-type;\n        color: @grey-90;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n\n    .remove-button {\n      position: absolute;\n      top: 15px;\n      right: 0;\n      vertical-align: top;\n\n      .icon-wrapper.icon {\n        vertical-align: top;\n      }\n\n      .icon {\n        width: 11px;\n        height: auto;\n        fill: @grey-80;\n      }\n    }\n  }\n}\n",".checkout-summary {\n  margin: 10px 0;\n\n  > button {\n    margin-bottom: 10px;\n  }\n\n  .price-row {\n    color: @grey-80;\n    font-size: @m-type;\n    line-height: 20px;\n    margin-top: 10px;\n\n    .title-group {\n      display: inline-flex;\n      align-items: center;\n    }\n\n    .value {\n      float: right;\n    }\n\n    &.total {\n      color: @grey-100;\n      font-weight: @semi-bold;\n    }\n  }\n}\n",".accepting-orders {\n  .checkout-button-wrapper {\n    display: flex;\n    justify-content: center;\n\n    .checkout-button {\n      margin: 20px;\n      width: 80%;\n\n      &.min-not-met {\n        height: 66px;\n      }\n\n      .min-requirement {\n        font-size: @xs-type;\n        font-weight: @regular;\n      }\n    }\n  }\n}\n",".cart-change-modal {\n  .contents {\n    p {\n      padding: 0 10px 0 10px;\n    }\n  }\n\n  .button {\n    width: 80%;\n    margin-left: 30px;\n  }\n\n  .confirm-actions {\n    margin-bottom: 30px;\n    margin-top: 50px;\n  }\n}\n",".items-removed-modal {\n  .confirm-actions {\n    margin-bottom: 30px;\n    margin-top: 50px;\n\n    .button {\n      display: block;\n      width: 100%;\n      margin-left: 10px 0;\n      height: 50px;\n      box-sizing: border-box;\n      font-size: @m-type;\n      line-height: 50px;\n    }\n  }\n}\n",".menu {\n  .menu-section {\n    box-sizing: border-box;\n\n    &:last-of-type {\n      margin-bottom: 20px;\n    }\n\n    //  Qualify with h2 to avoid collision with menu item's .name class\n    h2.name {\n      cursor: pointer;\n      padding: 20px 0;\n\n      .not-selectable();\n\n      .icon {\n        width: 16px;\n        height: auto;\n        fill: @blue;\n        margin-right: 12px;\n      }\n    }\n\n    @import \"online_ordering/menu/menu_items\";\n  }\n}\n","@menu-gutter-size: 20px;\n@column-width: calc(50% - ((@menu-gutter-size / 2)));\n@thumbnail-size: 140px;\n\n.menu-items {\n  display: grid;\n  grid-gap: @menu-gutter-size;\n  grid-template-columns: @column-width @column-width;\n  grid-template-rows: @thumbnail-size;\n  overflow: hidden;\n\n  .menu-item {\n    .not-selectable();\n    box-sizing: border-box;\n    background-color: @white;\n    cursor: pointer;\n    display: flex;\n    height: @thumbnail-size;\n    line-height: 1.5em;\n    display: flex;\n\n    &.out-of-stock {\n      .name,\n      .description,\n      .price {\n        color: @grey-80;\n      }\n\n      cursor: default;\n    }\n\n    .content-box {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-around;\n      flex: 1;\n      padding: 10px 15px;\n      -ms-hyphens: auto;\n      -moz-hyphens: auto;\n      -webkit-hyphens: auto;\n      hyphens: auto;\n    }\n\n    .name {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      color: @grey-90;\n      display: inline-block;\n      font-size: 14px;\n      font-weight: @semi-bold;\n      max-width: 300px;\n      display: -webkit-box;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      line-height: 21px;\n      max-height: 21px;\n    }\n\n    .description {\n      display: -webkit-box;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      color: @grey-90;\n      flex: 1;\n      margin-bottom: 20px;\n      padding-right: 10px;\n      line-height: 21px;\n      max-height: 42px;\n      font-size: @s-type;\n      white-space: pre-wrap;\n      overflow-y: auto;\n    }\n\n    .thumbnail {\n      width: 100%;\n      height: 100%;\n      max-width: @thumbnail-size;\n      max-height: @thumbnail-size;\n    }\n  }\n\n  &.expanding-enter {\n    max-height: 0;\n\n    &.expanding-enter-active {\n      transition: max-height 300ms ease-in;\n      max-height: 300px;\n    }\n  }\n\n  &.expanding-exit {\n    max-height: 300px;\n\n    &.expanding-exit-active {\n      transition: max-height 300ms ease-out;\n      max-height: 0;\n    }\n  }\n}\n",".main-view {\n  flex: 1;\n  padding-right: 20px;\n\n  .store-description {\n    padding: 20px;\n    margin: 20px 0;\n    white-space: pre-wrap;\n  }\n}\n",".checkout {\n  padding: 20px 100px 20px 20px;\n  margin-bottom: 20px;\n\n  .delivery-instructions,\n  .curbside-pickup-instructions {\n    margin: 10px 0;\n    overflow: hidden;\n\n    .curbside-pickup-guest-instructions {\n      margin: 10px 0;\n    }\n\n    label {\n      color: @grey-90;\n      font-weight: @semi-bold;\n      font-size: @s-type;\n    }\n\n    textarea {\n      width: 100%;\n      box-sizing: border-box;\n      border-color: @grey-60;\n      border-width: 1px;\n      resize: none;\n      height: 76px;\n      border-radius: @radius;\n    }\n\n    .length-left {\n      float: right;\n      clear: both;\n      font-size: @s-type;\n      color: @grey-90;\n    }\n  }\n\n  .should-copy {\n    padding-left: 120px;\n  }\n\n  .submit-button-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 20px;\n\n    text-align: center;\n\n    .submit-order {\n      width: 200px;\n    }\n  }\n\n  @import \"online_ordering/checkout/gratuity\";\n  @import \"online_ordering/checkout/payment\";\n}\n\n.order-error {\n  color: @red;\n  font-weight: @semi-bold;\n  margin-bottom: 1rem;\n\n  button {\n    margin: 10px 0;\n  }\n}\n\n.text-input {\n  input {\n    color: @grey-95;\n  }\n}\n",".gratuity {\n  margin: 2.5rem 0 1.75rem;\n  .options {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 78%;\n\n    .text-input {\n      flex-grow: 0;\n    }\n  }\n\n  .gratuity-option {\n    border: @border;\n    color: @grey-80;\n    font-weight: @light;\n\n    &.selected {\n      border: 1px solid @blue;\n    }\n  }\n\n  .gratuity-custom {\n    border: @border;\n    border-radius: @radius;\n    font-size: @s-type;\n    max-height: 34px;\n    padding: 5px;\n    position: relative;\n    &.selected {\n      border: 1px solid @blue;\n      &::before {\n        content: \"$\";\n        color: @grey-80;\n        position: absolute;\n        left: 8px;\n        top: calc(5px + 0.6rem);\n      }\n    }\n    input {\n      border: none;\n      color: @grey-80;\n      font-size: inherit;\n      font-weight: @light;\n      padding: 0;\n      text-align: center;\n      width: 90px;\n\n      &:focus {\n        outline: none;\n      }\n    }\n  }\n}\n",".payment {\n  margin: 24px 0;\n\n  .toggle {\n    margin: 10px 0;\n  }\n\n  &.expanding-enter {\n    max-height: 0;\n\n    &.expanding-enter-active {\n      transition: max-height 300ms ease-in;\n      max-height: 415px;\n    }\n  }\n\n  &.expanding-exit {\n    max-height: 415px;\n\n    &.expanding-exit-active {\n      transition: max-height 300ms ease-out;\n      max-height: 0;\n    }\n  }\n}\n",".item-modal {\n  cursor: default;\n  overflow: hidden;\n  width: 600px;\n  .selectable();\n\n  .modal-content {\n    padding: 20px;\n    max-height: 60vh;\n    overflow-y: scroll;\n\n    .description-full {\n      color: @grey-90;\n      font-size: @s-type;\n      line-height: 21px;\n      margin-top: 10px;\n      margin-bottom: 20px;\n      white-space: pre-wrap;\n    }\n\n    .item-image-container {\n      position: relative;\n      height: 300px;\n      width: 100%;\n      overflow: hidden;\n\n      .item-background-overlay {\n        background-position: left;\n        background-size: 100%;\n        background-repeat: no-repeat;\n        height: 300px;\n        z-index: 1;\n        -webkit-filter: blur(3px);\n        -moz-filter: blur(3px);\n        -o-filter: blur(3px);\n        -ms-filter: blur(3px);\n        filter: blur(3px);\n      }\n\n      .item-blurred-background {\n        position: absolute;\n        top: 0;\n        background-color: fade(@black, 70%);\n        height: 300px;\n        width: 100%;\n        z-index: 2;\n      }\n\n      .item-image-main {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        display: block;\n        height: 300px;\n        margin: 0 auto;\n        z-index: 5;\n      }\n    }\n\n    .section {\n      margin-bottom: 25px;\n\n      .title {\n        font-weight: @semi-bold;\n        color: @grey-90;\n      }\n    }\n\n    .instructions-input {\n      padding: 10px;\n      box-sizing: border-box;\n      border-radius: @radius;\n      border: @border;\n      font-size: @s-type;\n      height: 90px;\n      margin-top: 10px;\n      resize: none;\n      width: 100%;\n\n      &:placeholder-shown {\n        color: @grey-80;\n      }\n    }\n\n    @import \"online_ordering/item_modal/quantity_selector\";\n    @import \"online_ordering/item_modal/modifier_section\";\n  }\n\n  .item-modal-footer {\n    height: 68px;\n    padding: 14px 20px;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: @grey-40;\n\n    .subtotal {\n      color: @grey-90;\n      font-size: @xl-type;\n      font-weight: @regular;\n    }\n  }\n}\n",".quantity-wrapper {\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n\n  .quantity-selector {\n    .not-selectable();\n\n    .quantity-value {\n      color: @grey-80;\n      display: inline-block;\n      font-size: @xxl-type;\n      position: relative;\n      top: 4px;\n      width: 38px;\n      text-align: center;\n\n      &:focus {\n        outline: none;\n      }\n    }\n\n    .increment,\n    .decrement {\n      background: transparent;\n      border-radius: @radius;\n      border: 1px solid @blue;\n      color: @blue;\n      cursor: pointer;\n      display: inline-block;\n      font-size: @xxxl-type;\n      height: 38px;\n      line-height: 38px;\n      padding: 0;\n      text-align: center;\n      vertical-align: middle;\n      width: 38px;\n\n      &:disabled {\n        cursor: not-allowed;\n        opacity: 0.3;\n      }\n    }\n\n    .decrement {\n      line-height: 35px;\n    }\n  }\n\n  .quantity-info {\n    margin-left: 10px;\n    font-size: @m-type;\n    color: @grey-90;\n  }\n}\n",".modifier-section,\n.side-section {\n  .section-title {\n    align-items: baseline;\n    display: flex;\n    margin-bottom: 10px;\n\n    .restrictions {\n      font-size: @s-type;\n      margin-left: 10px;\n    }\n\n    .required {\n      color: @red;\n    }\n\n    .max-reached {\n      color: @green;\n      font-size: @s-type;\n      margin-left: auto;\n    }\n  }\n\n  .options {\n    color: @grey-90;\n    display: flex;\n    flex-flow: row wrap;\n    flex-basis: 100%;\n    padding: 0 10px;\n\n    .modifier,\n    .side {\n      flex-basis: 33%;\n      font-size: @s-type;\n      font-weight: @regular;\n      margin-bottom: 10px;\n    }\n\n    .side-price,\n    .mod-price {\n      color: @grey-90;\n    }\n  }\n}\n",".tooltip {\n  display: inline-block;\n  margin-left: 5px;\n  vertical-align: middle;\n\n  .tooltip-icon-wrapper {\n    height: 20px;\n    width: 20px;\n    outline: none;\n  }\n}\n",".order-confirm-modal {\n  padding: 20px;\n  text-align: center;\n  width: 60vw;\n  min-height: 170px;\n\n  .close {\n    .icon {\n      top: 5px;\n    }\n  }\n\n  .check-icon {\n    height: 150px;\n    margin: 20px auto;\n    width: auto;\n  }\n\n  .delivery-address {\n    font-size: @xl-type;\n    margin-top: 20px;\n\n    .customer-name,\n    .customer-address {\n      color: @grey-90;\n      font-weight: @regular;\n    }\n  }\n\n  .store-address {\n    font-size: @xl-type;\n  }\n\n  .store-phone {\n    color: @blue;\n    font-size: @xl-type;\n    margin-bottom: 20px;\n  }\n\n  .order-payment-method {\n    border-bottom: @border;\n    font-size: @s-type;\n    padding: 20px;\n  }\n\n  .email-message {\n    margin: 0 auto 20px;\n    width: 80%;\n\n    .email {\n      color: @blue;\n    }\n  }\n\n  .order-number {\n    font-weight: @regular;\n    margin-bottom: 10px;\n  }\n\n  .indicator {\n    top: -100px;\n  }\n}\n","&.account {\n  .back-button {\n    display: inline-block;\n    margin: 12px 5px;\n  }\n\n  .form {\n    max-width: 540px;\n  }\n\n  .expanded-form {\n    background-color: @grey-40;\n    border-radius: @radius;\n    margin: 0 0 20px -10px;\n    padding: 20px 20px 20px 20px;\n    overflow: hidden;\n  }\n\n  .buttons {\n    clear: both;\n    display: flex;\n    justify-content: flex-end;\n\n    .button {\n      margin-left: 5px;\n      min-width: 150px;\n    }\n  }\n\n  .account-settings {\n    width: 100%;\n    padding: 14px;\n    box-sizing: border-box;\n\n    .account-section {\n      padding: 6px 24px;\n      border-top: @border;\n    }\n\n    @import \"account/contact_info\";\n    @import \"account/password\";\n  }\n\n  @import \"account/addresses\";\n  @import \"account/credit_card_list\";\n  @import \"account/order_history\";\n}\n",".contact-info {\n  @keyframes fade {\n    0% { opacity: 1; }\n    20% { opacity: 1; }\n    100% { opacity: 0; }\n  }\n\n  .updated-text {\n    display: inline-block;\n    width: 56px;\n    margin-left: 10px;\n    font-size: @s-type;\n    color: @green;\n    opacity: 0;\n    animation: fade 3s ease-in;\n  }\n\n  .name {\n    .text-input + .text-input {\n      margin-left: 12px;\n    }\n  }\n}\n",".password {\n  border-top: @border;\n\n  .title {\n    display: inline-block;\n  }\n\n  .edit-button {\n    display: inline-block;\n    margin-left: 30px;\n  }\n}\n",".address-list-wrapper {\n  border-top: @border;\n\n  .address-list {\n    padding-left: 12px;\n  }\n\n  @import 'account/address';\n}\n",".address {\n  margin: 15px 0;\n\n  .actions {\n    display: inline-block;\n\n    .update {\n      cursor: pointer;\n\n      &.edit {\n        border-right: @border;\n        margin-left: 20px;\n        padding-right: 10px;\n        color: @blue;\n      }\n\n      &.remove {\n        color: @red;\n        margin-left: 10px;\n      }\n    }\n  }\n}\n",".credit-card {\n  .card-icon {\n    width: 3em;\n  }\n\n  .actions {\n    .update {\n      cursor: pointer;\n\n      &.remove {\n        color: @red;\n      }\n    }\n  }\n}\n",".order-history {\n  border-top: @border;\n\n  .order-history-table {\n    width: 100%;\n\n    th, td {\n      padding-right: 24px;\n      text-align: center;\n\n      &.date {\n        text-align: left;\n      }\n    }\n\n    td {\n      border-top: @border;\n\n      white-space: nowrap;\n\n      &.date {\n        font-weight: @regular;\n      }\n\n      &.space-fill {\n        width: 100%;\n      }\n    }\n  }\n}\n",".modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: auto;\n  height: auto;\n  transform: none;\n  border-radius: 0;\n\n  header {\n    .title {\n      display: none;\n    }\n\n    .mobile-title {\n      display: block;\n      color: @grey-90;\n      font-size: @xl-type;\n    }\n  }\n}\n",".picker {\n  width: 100%;\n}\n",".alert-modal {\n  .contents {\n    width: auto;\n    padding: 0 18px;\n    text-align: left;\n  }\n}\n",".confirm-modal {\n  .contents {\n    .confirm-actions {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      padding: 20px;\n      display: flex;\n      flex-wrap: wrap;\n\n      .button {\n        width: 100%;\n        margin-bottom: 10px;\n        flex-basis: 100%;\n        flex-shrink: 0;\n        margin-left: 0;\n        box-sizing: border-box;\n\n        &.confirm {\n          order: 1;\n        }\n\n        &.cancel {\n          order: 2;\n        }\n      }\n    }\n  }\n}\n",".form {\n  width: 100%;\n\n  .row {\n    flex-direction: column;\n    align-items: stretch;\n\n    .multi-field {\n      margin-left: 0;\n    }\n\n    .label, label {\n      margin: 0 0 5px 0;\n    }\n\n    label.cvv, label.zip {\n      margin: 13px 4px 5px 0;\n    }\n\n    .expiry-divider {\n      display: none;\n    }\n  }\n}\n\n.text-input {\n  input {\n    font-size: @xl-type; // Inputs that have a font-size smaller than 16px will cause a zoom on mobile\n    &.exp {\n      max-height: 42px;\n    }\n  }\n}\n",".preview-banner {\n  height: 100%;\n  padding: 10px 0;\n\n  .inner {\n    width: 100%;\n    flex-direction: column;\n\n    .right {\n      align-self: flex-start;\n    }\n  }\n\n  a {\n    text-decoration: underline;\n  }\n}\n","@import \"mobile/modal\";\n@import \"mobile/picker\";\n@import \"mobile/alert_modal\";\n@import \"mobile/confirm_modal\";\n@import \"mobile/forms\";\n@import \"mobile/online_ordering/preview_banner\";\n\n.app {\n  width: 100%;\n\n  @import \"mobile/header\";\n  @import \"mobile/footer\";\n\n  .content {\n    width: 95vw;\n    margin: 0 auto;\n\n    @import \"mobile/loyalty\";\n    @import \"mobile/location_info\";\n\n    .address-list-wrapper {\n      @import \"mobile/account/address\";\n    }\n\n    @import \"mobile/online_ordering/menu\";\n    @import \"mobile/online_ordering/main_view\";\n    @import \"mobile/online_ordering/cart\";\n    @import \"mobile/online_ordering/item_modal\";\n    @import \"mobile/online_ordering/checkout\";\n    @import \"mobile/online_ordering/checkout/order_confirm_modal\";\n    @import \"mobile/online_ordering/cart/items\";\n  }\n\n  @import \"mobile/account\";\n}\n",".header {\n  background-position: center;\n  padding: 15px 20px;\n\n  .location-name {\n    font-size: @xxl-type;\n  }\n\n  .login {\n    align-self: flex-start;\n    color: @white;\n\n    .text,\n    .separator,\n    .address-spacer {\n      display: none;\n    }\n\n    .icon.user {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .hide-on-mobile {\n    display: none;\n  }\n\n  .login-modal {\n    .contents {\n      width: auto;\n      padding: 0 18px;\n    }\n  }\n\n  .reset-password-modal {\n    .contents {\n      width: auto;\n      padding: 0 18px;\n      text-align: left;\n    }\n  }\n}\n",".footer {\n  width: 100%;\n  height: 70px;\n  text-align: center;\n  visibility: hidden; // retain spacing but make room for a sticky checkout button\n\n  .separator, .outside-reference {\n    display: none;\n  }\n\n  .upserve {\n    font-size: @l-type;\n    font-weight: @regular;\n    width: 100%;\n\n    .powered {\n      color: @grey-100;\n    }\n\n    .logo-icon {\n      height: 25px;\n      width: auto;\n      position: relative;\n      top: 2px;\n      left: 4px;\n    }\n  }\n}\n",".loyalty {\n  width: 100%;\n  .rewards {\n    width: 100%;\n\n    .reward {\n      .reward-photo {\n        display: none;\n      }\n    }\n\n    .reward-progress-bar {\n      width: 100%;\n    }\n  }\n\n  .loyalty-sign-up {\n    .email-entry, .card-entry {\n      .email-form, .card-form {\n        flex-wrap: wrap;\n\n        .text-input {\n          margin-right: 0;\n          margin-bottom: 20px;\n        }\n\n        .button {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  .location-info {\n    .lower {\n      flex-wrap: wrap;\n    }\n  }\n}\n",".location-info {\n  margin-bottom: 20px;\n\n  .lower {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .address-column,\n  .promo-description {\n    width: 300px;\n  }\n\n  .promo-description {\n    margin: 0 auto;\n  }\n}\n",".address {\n  .actions {\n    display: block;\n\n    .update {\n      &.edit {\n        margin-left: 0 ;\n      }\n    }\n  }\n}\n",".menu {\n  .menu-section {\n    padding: 10px 0 0;\n    width: 93vw;\n\n    &:last-of-type {\n      margin-bottom: 20px;\n    }\n\n    @import 'mobile/online_ordering/menu/menu_items';\n  }\n}\n",".menu-items {\n  grid-template-columns: 100%;\n}\n",".main-view {\n  padding: 0;\n  width: 100%;\n}\n",".cart {\n  flex-basis: 100%;\n  order: -1;\n  min-height: 0;\n\n  &.fixed-cart {\n    // We don't want the cart to stick on mobile\n    position: static;\n\n    // make room for the sticky checkout button\n    margin-bottom: 40px;\n  }\n\n  .ordering-not-available {\n    margin-top: 0;\n  }\n\n  @import \"mobile/online_ordering/cart/edit_ordering_options\";\n  @import \"mobile/online_ordering/cart/accepting_orders\";\n}\n",".edit-ordering-options {\n  .cart-prompt {\n    margin-top: 10px;\n    margin-bottom: 20px;\n  }\n\n  .delivery-address-container {\n    input {\n      width: 88%;\n      padding: 5px 0px 5px 35px;\n    }\n\n    .geolocation-container {\n      display: unset;\n    }\n\n    .icon .geolocation {\n      position: relative;\n      left: 0;\n      top: 48px;\n      padding: 9px 8px;\n    }\n  }\n}\n",".accepting-orders {\n  .checkout-button-wrapper {\n    position: fixed;\n    bottom:0;\n    left: 0;\n    right: 0;\n    background: @white;\n  }\n}\n",".item-modal {\n  width: 100vw;\n\n  .modal-content {\n    height: 100%;\n    padding-bottom: 130px;\n\n    @import 'mobile/online_ordering/item_modal/modifier_section';\n  }\n\n  .item-modal-footer {\n    bottom: 0;\n    position: fixed;\n    width: 100%;\n  }\n}\n",".modifier-section, .side-section {\n  .section-title {\n    flex-direction: column;\n\n    .restrictions {\n      margin-left: 0;\n    }\n\n    .required {\n      color: @red;\n    }\n\n    .max-reached {\n      margin-left: 0;\n    }\n  }\n\n  .options {\n    flex-flow: column nowrap;\n    padding: 0;\n\n    .modifier, .side {\n      flex-basis: 0;\n    }\n  }\n}\n",".checkout {\n  padding-right: 20px;\n\n  .should-copy {\n    padding-left: 0;\n  }\n\n  .submit-order {\n    width: 90%;\n    align-self: center;\n    margin-top: 10px;\n  }\n\n  @import 'mobile/online_ordering/checkout/payment';\n  @import 'mobile/online_ordering/checkout/gratuity';\n}\n",".payment {\n  .credit-card-picker {\n    margin-top: 24px;\n  }\n\n  .new-credit-card-form {\n    label.cvv, label.zip {\n      margin: 13px 4px 5px 0;\n    }\n\n    .expiry-divider {\n      display: none;\n    }\n  }\n}\n",".gratuity {\n  .options {\n    width: 100%;\n  }\n\n  .gratuity-option {\n    padding-left: 3vw;\n    padding-right: 3vw;\n  }\n}\n",".order-confirm-modal {\n  padding: 10px;\n  width: calc(100vw - 20px);\n}\n",".cart .items {\n  height: auto;\n}\n","&.account {\n  .buttons {\n    flex-direction: column-reverse;\n    align-items: stretch;\n\n    .button {\n      margin-bottom: 10px;\n      max-width: none;\n    }\n  }\n\n  .content {\n    padding: 0;\n\n    .account-settings {\n      .contact-info {\n        width: auto;\n\n        .name {\n          .text-input + .text-input {\n            margin-left: 0;\n            margin-top: 10px;\n          }\n        }\n      }\n    }\n  }\n}\n",".tooltip-portal {\n  line-height: 1.5;\n  position: fixed;\n\n  .triangle {\n    background-color: @white;\n    border-bottom: 1px @grey-80 solid;\n    border-left: 1px solid @grey-80;\n    border-top: 1px transparent solid;\n    bottom: -8px;\n    height: 16px;\n    position: absolute;\n    width: 16px;\n    z-index: 11;\n  }\n\n  &.positionRight .triangle {\n    left: 17px;\n    transform: rotateY(0deg) rotate(45deg);\n  }\n  &.positionLeft .triangle {\n    right: 17px;\n    transform: rotateY(0deg) rotate(225deg);\n  }\n\n  .content {\n    background-color: @white;\n    border-radius: 5px;\n    border: 1px @grey-80 solid;\n    height: auto;\n    max-height: 300px;\n    padding: 16px;\n    position: absolute;\n    transform: translateY(-50%);\n    width: 250px;\n    z-index: 10;\n\n    &.isNarrow {\n      width: 150px;\n    }\n\n    dd,\n    dt {\n      color: @grey-100;\n    }\n\n    #asterisk {\n      color: @grey-90;\n      margin-bottom: 5px;\n    }\n  }\n\n  &.positionRight .content {\n    left: 25px;\n  }\n  &.positionLeft .content {\n    right: 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
